// @ts-nocheck
import Text from "src/components/text/text";
import Image from "src/components/image";
import {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useCallback,
  Suspense,
  useImperativeHandle,
  Ref,
  forwardRef,
  useMemo,
} from "react";
import { useNavigationStore } from "src/store/navigationStore";
import { AMPLITUDE_EVENT, EVENT, trackGAEvent } from "@/utils/analytics";
import { trackEvent } from "@/amplitudeClient";
import {
  NavigationData,
  NavigationPath,
  NavigationSequence,
  NavigationCheckpointData,
} from "@/types/navigation";
import { useAppStore } from "@/store/appStore";
import { useLanguageStore } from "@/store/languageStore";
import { isLift, isEscalator, isStair } from "src/utils/navigation";
import { useLodSplat } from "src/utils/useLodSplat";

import { CoordinateUtil } from "src/utils/CoordinateUtil";

import {
  IMapAlign,
  calculateXy,
  findMapAlignWithLcMapId,
  getVenueMapInformationByVenueId,
  findMapAlignWithGisLevelId,
  getVenueShortNameById,
  getMapAlignById,
  getAllFloorMapAlignByVenueId,
  getVenueModelConfigByVenueCode,
  getBaseUrl,
  getVenueIdByVenueCode,
  getStartPointNameByVenueCode,
  getEndPointNameByVenueCode,
  getMapSettingByVenueCode,
  AnnotationTagScreenPosType,
  AnnotationTagPositionType,
  AnnotationTagColorPool,
  getModelConfigMapByLcMapId,
} from "src/utils/map-util";
import { useNavigate } from "react-router-dom";

import Lottie from "lottie-react";
import loading from "src/components/lottie/loading.json";

import {
  // getFloorNumber,
  getPreviousNumber,
  getPreviousValueArray,
  getStartValueArray,
  getEndValueArray,
  getNextEndValueArray,
  getFloorString,
  getInterpolatedNumberArray,
  // getLowerNumberArray,
  isLastNumberArray,
  getFloorNumberArray,
  initCameraMovement,
  hasChinese,
} from "src/const/navigationConst";

import WatermarkScreen from "src/components/watermark";
import useMessagePlayer from "@/hooks/useMessagePlayer";

import {
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  calculateLookAtRotation,
  interpolateVector3,
  getNewFrontPosition,
} from "src/utils/game";
import * as pc from "playcanvas";
import { OrbitControls } from "@playcanvas/react/scripts";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
  useFont,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Anim,
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
  RigidBody,
  Collision,
  Element,
} from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";
import { GsplatRevealRadial } from "src/extra_js/reveal-radial.mjs";
import useAudioPlayer from "@/hooks/useAudioPlayer";

import {
  createRadialScript,
  createRadialScriptFast,
  SplatLodComponent,
  SplatSogComponent,
  RobotAvatar,
  MeshModelComponent,
  FloorMeshComponent,
  installCameraNearFar,
} from "@/components/playcanvas/playcanvasComponents";

export default function NavigationPage() {
  const setProgress = useNavigationStore((state) => state.setProgress);
  const setCalculatePosition = useNavigationStore(
    (state) => state.setCalculatePosition,
  );
  const setFullDistance = useNavigationStore((state) => state.setFullDistance);
  const setFullDuration = useNavigationStore((state) => state.setFullDuration);
  const setCurrentVenueId = useNavigationStore(
    (state) => state.setCurrentVenueId,
  );
  const setCurrentVenue = useNavigationStore((state) => state.setCurrentVenue);

  // const setCurrentLevel = useNavigationStore((state) => state.setCurrentLevel);
  // const setCurrentLevelIndex = useNavigationStore(
  //   (state) => state.setCurrentLevelIndex,
  // );

  const setCurrentLcMapId = useNavigationStore(
    (state) => state.setCurrentLcMapId,
  );

  const setCurrentLevelShortName = useNavigationStore(
    (state) => state.setCurrentLevelShortName,
  );

  const setStartPointName = useNavigationStore(
    (state) => state.setStartPointName,
  );
  const setEndPointName = useNavigationStore((state) => state.setEndPointName);

  const setNavigationAngle = useNavigationStore(
    (state) => state.setNavigationAngle,
  );
  const setNavigationMessage = useNavigationStore(
    (state) => state.setNavigationMessage,
  );
  const setNavigationCheckpoint = useNavigationStore(
    (state) => state.setNavigationCheckpoint,
  );
  const setCameraMode = useNavigationStore((state) => state.setCameraMode);

  const setNavigationCameraPosition = useNavigationStore(
    (state) => state.setNavigationCameraPosition,
  );
  const setNavigationCameraLookingPosition = useNavigationStore(
    (state) => state.setNavigationCameraLookingPosition,
  );
  const setNavigationPercentagePositionDictionary = useNavigationStore(
    (state) => state.setNavigationPercentagePositionDictionary,
  );
  const startAutoPlayDelay = useNavigationStore(
    (state) => state.startAutoPlayDelay,
  );

  const enableXRayMode = useNavigationStore((state) => state.enableXRayMode);
  const enableAnnotationMode = useNavigationStore(
    (state) => state.enableAnnotationMode,
  );

  const setSceneAnimationState = useNavigationStore(
    (state) => state.setSceneAnimationState,
  );
  const setLoading = useNavigationStore((state) => state.setLoading);
  const setIsDisplayUI = useNavigationStore((state) => state.setIsDisplayUI);
  const setIsDisplayTopViewScene = useNavigationStore(
    (state) => state.setIsDisplayTopViewScene,
  );
  const setIsShowNavigationContinueButton = useNavigationStore(
    (state) => state.setIsShowNavigationContinueButton,
  );
  const setIsShowNavigationRestartButton = useNavigationStore(
    (state) => state.setIsShowNavigationRestartButton,
  );
  const setIsDisplayDragScreenSliderAnimation = useNavigationStore(
    (state) => state.setIsDisplayDragScreenSliderAnimation,
  );

  const setIsDisplaySkipPreview = useNavigationStore(
    (state) => state.setIsDisplaySkipPreview,
  );

  const THIRD_PERSION_DISTANCE = 4;
  const SCALE_BASE = 1500;

  const navigate = useNavigate();
  const navEventData = useNavigationStore((state) => state.navEventData);

  //NEW

  const gsplatMainRef = useRef();
  const gsplatAllRef = useRef({});
  const splatDisplayFloor = useRef<number[]>();

  const previousProgressRef = useRef<number>(0);
  const playDirectionRef = useRef<string>("forward");
  const latestProgressRef = useRef<number>(0);
  const latestAllFloorMapAlignRef = useRef<IMapAlign[]>(null);

  const AUTOPLAY_SPEED = 4;
  const autoPlaySpeedRef = useRef<number>(AUTOPLAY_SPEED);

  const [mapSettingState, setMapSettingState] = useState<MapInformation>(null);
  const mapSettingRef = useRef<MapInformation>(null);
  const currentModelScaleFactorRef = useRef(1);

  // const [venueModelConfigState, setVenueModelConfigState] = useState<number>(0);

  // const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);

  //const [modelScaleFactorState, setModelScaleFactorState] = useState<number>(0);

  const isMouseDraggingRef = useRef<boolean>(false);
  const isMouseDraggingTimeoutRef = useRef<ReturnType<
    typeof setTimeout
  > | null>(null);
  const isTouchDraggingRef = useRef<boolean>(false);
  const isTouchDraggingTimeoutRef = useRef<ReturnType<
    typeof setTimeout
  > | null>(null);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestNavigationDataRef = useRef<NavigationData>(null);
  const latestNavigationPathRef = useRef<NavigationPath>(null);
  const latestCameraPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const latestNavigationMessage = useRef<string>("");
  // const latestIsNoModelDataRef = useRef<boolean>(false);

  const navigationPercentageMessageDictionaryRef = useRef<
    Record<number, string>
  >({});

  // const latestCurrentLevelIndexRef = useRef<number>(0);
  // const currentNextLevelIndexRef = useRef<number>(0);
  const currentLcMapIdRef = useRef("");
  const nextNodeLcMapIdRef = useRef("");

  const currentModelConfigMapRef = useRef();

  const navigationPositionArrayRef = useRef<pc.Vec3[]>([]);
  const navigationTargetArrayRef = useRef<pc.Vec3[]>([]);
  const navigationIdArrayRef = useRef<string[]>([]);
  const navigationLevelArrayRef = useRef<string[]>([]);

  const navigationObjectDesiredPositionRef = useRef<pc.Vec3>(
    new pc.Vec3(0, 0, 0),
  );
  const navigationObjectDesiredTargetRef = useRef<pc.Vec3>(
    new pc.Vec3(0, 0, 0),
  );

  const navigationFloorCamerasRef = useRef<Record<string, pc.Vec3[]>>({});

  const isAutoPlayingRef = useRef<boolean>(false);
  const isFirstAutoPlayedRef = useRef<boolean>(false);

  const autoPlayTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const latestCameraModeRef = useRef<number>(0);
  const latestXrayModeRef = useRef<number>(0);
  const latestAnnotationModeRef = useRef<number>(0);

  const navigationPercentageLevelDictionaryRef = useRef<Record<number, string>>(
    {},
  );
  const latestNavigationPercentageMessageDictionary = useRef<
    Record<number, string>
  >({});
  const latestNavigationPercentagePositionDictionary = useRef<
    Record<number, number[]>
  >({});
  const latestNavigationPercentageTargetDictionary = useRef<
    Record<number, number[]>
  >({});
  const latestNavigationPercentagePathTypeDictionary = useRef<
    Record<number, number>
  >({});
  // const latestNavigationPercentageLevelIndexDictionary = useRef<
  //   Record<number, number>
  // >({});
  const latestNavigationPercentageLcMapIdDictionary = useRef<
    Record<number, string>
  >({});

  const latestNavigationLevelShortNameDictionaryRef = useRef<
    Record<string, string>
  >({});

  const latestFullDuration = useRef<number>(0);
  const latestFullDistance = useRef<number>(0);

  //Init animation
  const isDisplayEnteringMaskRef = useRef<boolean>(false);
  const sceneAnimationStateRef = useRef("init");
  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const revealEffectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const isDisplayAvatarRef = useRef<boolean>(false);
  const isDisplayStartEndPointDivRef = useRef<boolean>(false);
  const isDisplayStartEndPointFirstRef = useRef<boolean>(false);
  const isDisplayStartEndPointSecondRef = useRef<boolean>(false);
  const isDisplayStartEndPointThirdRef = useRef<boolean>(false);
  const isDisplayStartEndPointStartRef = useRef<boolean>(false);
  const isDisplayStartEndPointEndRef = useRef<boolean>(false);

  //Preview
  const isEnableDragRef = useRef<boolean>(false);
  const isDisplayBlackScreenRef = useRef<boolean>(false);
  const finishPreviewTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  //Step by Step
  const isWaitingUserContinue = useRef<boolean>(false);
  const isNavigationHasChineseRef = useRef<boolean>(false);

  const isNavigationMapChangingRef = useRef<boolean>(false);

  const isNavigationReadyChangeMapRef = useRef<boolean>(false);

  const annotationJsonCacheRef = useRef({});
  const annotationColorRef = useRef({});
  const annotationUIRef = useRef<Record<string, HTMLDivElement | null>>({});

  const appRef = useRef();
  const mainCameraRef = useRef();
  const rigidbodySystemRef = useRef();

  const isSplatLoadingRef = useRef();
  const splatLoadingCountRef = useRef();

  useEffect(() => {
    setCameraMode(1);
    setIsDisplayTopViewScene(true);
    setIsShowNavigationContinueButton(false);
    setIsShowNavigationRestartButton(false);
    return () => {
      console.log("unmounting!!!!!!");
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
      if (revealEffectTimeoutRef.current) {
        clearTimeout(revealEffectTimeoutRef.current);
      }
      if (finishPreviewTimeoutRef.current) {
        clearTimeout(finishPreviewTimeoutRef);
      }
      stopAutoPlay();
      setIsDisplayUI(false);
      setIsShowNavigationContinueButton(false);
      setIsShowNavigationRestartButton(false);
      enableAnnotationMode(false);
    };
  }, []);

  function backToHome() {
    console.log("back to home");
    navigate("/");
  }

  function stopAutoPlay() {
    console.log("stop auto play");
    isAutoPlayingRef.current = false;
    if (autoPlayTimeoutRef.current) {
      clearTimeout(autoPlayTimeoutRef.current);
      autoPlayTimeoutRef.current = null;
    }
  }

  function resumeAutoPlay(milliseconds: number) {
    console.log("resumeAutoPlay: milliseconds=", milliseconds);
    if (isMouseDraggingRef.current || isTouchDraggingRef.current) {
      console.log("user dragging");
      return;
    }
    if (milliseconds > 0) {
      stopAutoPlay();
    }
    autoPlayTimeoutRef.current = setTimeout(() => {
      console.log("resume auto play");
      autoPlayTimeoutRef.current = null;
      isAutoPlayingRef.current = true;
    }, milliseconds);
  }

  function findNearestFixedCamera(level: number, currentPos: pc.Vec3) {
    let nearestPos = null;
    let minDistance = Infinity;

    const currentLevelCameras =
      navigationFloorCamerasRef.current[level.toString()];

    for (const pos of currentLevelCameras) {
      const cameraPosVector = new pc.Vec3(pos.x, pos.y, -pos.z);

      const distance = vec3Distance(cameraPosVector, currentPos);
      if (distance < minDistance) {
        minDistance = distance;
        nearestPos = pos;
      }
    }
    if (nearestPos == null) {
      return new pc.Vec3(0, 0, 0);
    } else {
      return new pc.Vec3(nearestPos.x, nearestPos.y, -nearestPos.z);
    }
  }

  function updateNavigation(percentage: number, mode: number = 0) {
    if (
      Object.keys(latestNavigationPercentagePositionDictionary.current)
        .length == 0 ||
      Object.keys(latestNavigationPercentageTargetDictionary.current).length ==
        0
    ) {
      return;
    }
    if (
      Object.keys(latestNavigationPercentagePositionDictionary.current)
        .length !=
      Object.keys(latestNavigationPercentageTargetDictionary.current).length
    ) {
      return;
    }
    const currentLcMapId = getStartValueArray(
      latestNavigationPercentageLcMapIdDictionary.current,
      percentage,
    );

    currentLcMapIdRef.current = currentLcMapId;
    const currentMapAlign = findMapAlignWithLcMapId(
      mapSettingRef.current.floorAlignment,
      currentLcMapId,
    );
    const currentScaleFactor = SCALE_BASE / currentMapAlign.scale;

    const currentModelConfigMap = getModelConfigMapByLcMapId(
      mapSettingRef.current.modelConfig,
      currentLcMapId,
    );
    currentModelConfigMapRef.current = currentModelConfigMap;

    const nextNodeLcMapId = getEndValueArray(
      latestNavigationPercentageLcMapIdDictionary.current,
      percentage,
    );
    nextNodeLcMapIdRef.current = nextNodeLcMapId;

    const nextNextNodeLcMapId = getNextEndValueArray(
      latestNavigationPercentageLcMapIdDictionary.current,
      percentage,
    );

    const currentMessage = getFloorString(
      latestNavigationPercentageMessageDictionary.current,
      percentage,
    );

    const currentPathType = getStartValueArray(
      latestNavigationPercentagePathTypeDictionary.current,
      percentage,
    );

    const currentPosition = getInterpolatedNumberArray(
      latestNavigationPercentagePositionDictionary.current,
      percentage,
    );

    const currentTarget = getInterpolatedNumberArray(
      latestNavigationPercentageTargetDictionary.current,
      percentage,
    );

    // const currentPosition =
    //   currentLcMapId == nextNodeLcMapId
    //     ? getInterpolatedNumberArray(
    //         latestNavigationPercentagePositionDictionary.current,
    //         percentage,
    //       )
    //     : getEndValueArray(
    //         latestNavigationPercentagePositionDictionary.current,
    //         percentage,
    //       );

    // const currentTarget =
    //   currentLcMapId == nextNodeLcMapId
    //     ? getInterpolatedNumberArray(
    //         latestNavigationPercentageTargetDictionary.current,
    //         percentage,
    //       )
    //     : getEndValueArray(
    //         latestNavigationPercentageTargetDictionary.current,
    //         percentage,
    //       );

    if (sceneAnimationStateRef.current == "stepByStep") {
      if (latestNavigationMessage.current != currentMessage) {
        latestNavigationMessage.current = currentMessage;
        if (
          currentMessage != null &&
          currentMessage != "" &&
          currentPathType != null
        ) {
          stopAutoPlay();
          isWaitingUserContinue.current = true;
          setIsShowNavigationContinueButton(true);
        }
      }
    }

    if (sceneAnimationStateRef.current == "stepByStep" && percentage == 1) {
      setIsShowNavigationRestartButton(true);
      console.log("TRACK NAV PREVIEW ENDED", navEventData);
      trackEvent(AMPLITUDE_EVENT.NAV_PREVIEW_ENDED, {
        navToken: navEventData.get("navToken") ?? "",
        referrer: navEventData.get("referrer") ?? "",
      });
    }

    if (sceneAnimationStateRef.current == "preview" && percentage == 1) {
      setIsDisplaySkipPreview(false);
      //TODO message
      if (isNavigationHasChineseRef.current) {
        setNavigationMessage("開始一步步講解");
      } else {
        setNavigationMessage("Start a step-by-step walkthrough.");
      }
      console.log("TRACK NAV_PREVIEW_STEPS_STARTED", navEventData);
      trackEvent(AMPLITUDE_EVENT.NAV_PREVIEW_STEPS_STARTED, {
        navToken: navEventData.get("navToken") ?? "",
        referrer: navEventData.get("referrer") ?? "",
      });
      stopAutoPlay();
      finishPreview(2000);
    }

    if (sceneAnimationStateRef.current == "stepByStep") {
      setNavigationMessage(currentMessage);
    }

    // setCurrentLevelIndex(currentLevelIndex);
    // setCurrentLevel(currentLevelName);
    setCurrentLcMapId(currentLcMapId);
    setCurrentLevelShortName(
      latestNavigationLevelShortNameDictionaryRef.current[currentLcMapId],
    );

    navigationObjectDesiredPositionRef.current.set(
      currentPosition[0],
      currentPosition[1],
      currentPosition[2],
    );

    isNavigationReadyChangeMapRef.current =
      currentLcMapId == nextNodeLcMapId &&
      currentLcMapId != nextNextNodeLcMapId;

    //only change focus if next next node still the same map unless it is changing map
    if (
      !isNavigationReadyChangeMapRef.current ||
      isNavigationMapChangingRef.current
    ) {
      navigationObjectDesiredTargetRef.current.set(
        currentTarget[0],
        currentTarget[1],
        currentTarget[2],
      );
    }
  }

  function finishPreview(timebase: number) {
    if (finishPreviewTimeoutRef.current) {
      clearTimeout(finishPreviewTimeoutRef);
    }
    finishPreviewTimeoutRef.current = setTimeout(() => {
      isDisplayBlackScreenRef.current = true;
    }, timebase);
    finishPreviewTimeoutRef.current = setTimeout(() => {
      setSceneAnimationState("previewFinish");
      setCameraMode(0);
      isDisplayAvatarRef.current = false;
      resetSlider();
      resetPosition();
    }, timebase + 500);
    finishPreviewTimeoutRef.current = setTimeout(() => {
      isDisplayBlackScreenRef.current = false;
      setIsDisplayUI(true);
      setSceneAnimationState("stepByStep");
      isEnableDragRef.current = true;
      setIsDisplayDragScreenSliderAnimation(true);
    }, timebase + 1200);
    finishPreviewTimeoutRef.current = setTimeout(() => {
      resumeAutoPlay(0);
    }, timebase + 2200);
    finishPreviewTimeoutRef.current = setTimeout(() => {
      setIsDisplayDragScreenSliderAnimation(false);
    }, timebase + 3200);
  }

  function updatePath(pathIndex: number = 0) {
    if (
      latestNavigationDataRef.current == null ||
      latestNavigationDataRef.current.nav.length == 0
    )
      return;
    let newNavigationObject = JSON.parse(
      JSON.stringify(latestNavigationDataRef.current.nav[pathIndex]),
    );

    setStartPointName(newNavigationObject?.startingPoi?.name ?? "");
    setEndPointName(newNavigationObject?.endPoi?.name ?? "");

    //check how many level contain in the path
    let floorList = [];
    newNavigationObject.navigation.forEach(function (node, index, array) {
      if (node.level != null) {
        if (!floorList.includes(node.level)) {
          floorList.push(node.level);
        }
      }
    });

    //filter the first navigation node if the first two lat long is the same
    if (newNavigationObject.navigation.length >= 2) {
      if (
        newNavigationObject.navigation[0].lat ==
          newNavigationObject.navigation[1].lat &&
        newNavigationObject.navigation[0].lng ==
          newNavigationObject.navigation[1].lng
      ) {
        //remove first node
        newNavigationObject.navigation = [
          ...newNavigationObject.navigation.slice(1),
        ];
      }
    }

    // newNavigationObject.navigation = newNavigationObject.navigation.filter(
    //   (item) => {
    //     const thisNodeMapAlign = findMapAlignWithGisLevelId(
    //       latestAllFloorMapAlignRef.current,
    //       item.levelId,
    //       [item.lng, item.lat],
    //     );
    //     if (!thisNodeMapAlign) {
    //       return false;
    //     }
    //     const modelConfigMap = getModelConfigMapByLcMapId(
    //       mapSettingRef.current.modelConfig,
    //       thisNodeMapAlign.lcMapId,
    //     );
    //     if (!modelConfigMap) {
    //       return false;
    //     }
    //     return true;
    //   },
    // );

    //filter the last checkpoint message approaching destination
    // const lastNode =
    //   newNavigationObject.navigation[newNavigationObject.navigation.length - 1];
    // if (lastNode.pathType == null || lastNode.distance == 0) {
    //   newNavigationObject.navigation[
    //     newNavigationObject.navigation.length - 1
    //   ].message = null;
    // }

    //filter all non floor changing message if there is a multiple level in the venue
    if (mapSettingRef.current.modelConfig!.floor) {
      const floorLength = Object.keys(
        mapSettingRef.current.modelConfig!.floor,
      ).length;
      if (floorLength > 1) {
        newNavigationObject.navigation.forEach(function (node, index, array) {
          if (node.pathType == 1) {
            newNavigationObject.navigation[index].message = null;
          }
        });
      }
    }

    // filter navigation node with 0 distance which is walk type and not the final node
    const lastNavigationIndex = newNavigationObject.navigation.length - 1;
    newNavigationObject.navigation = newNavigationObject.navigation.filter(
      (item: NavigationSequence, index: number) => {
        if (
          item.distance === 0 &&
          item.pathType === 1 &&
          index !== lastNavigationIndex
        ) {
          return false;
        }
        return true;
      },
    );

    //Ensure all lift and escalator distance is 0 , so we can standard the taking time.
    newNavigationObject.navigation.forEach(function (node, index, array) {
      if (
        isLift(node.pathType) ||
        isEscalator(node.pathType) ||
        isStair(node.pathType)
      ) {
        node.distance = 0;
      }
    });

    //Check how many change floor first , handle distance == 0
    const FLOOR_CHANGE_DISTANCE = 5;
    let floorChangeTime = 0;
    newNavigationObject.navigation.forEach(function (node, index, array) {
      if (node.distance == 0) {
        floorChangeTime++;
      }
    });

    //As we override some distance , not using the total distance in json , manual sum up the distance
    let totalDistance = 0;
    newNavigationObject.navigation.forEach(function (node, index, array) {
      totalDistance += node.distance;
    });

    //Add extra floor distance
    totalDistance += floorChangeTime * FLOOR_CHANGE_DISTANCE;

    let processedDistance = 0;

    let poiLat;
    let poiLng;
    if (newNavigationObject.endPoi) {
      poiLat = newNavigationObject.endPoi.lat;
      poiLng = newNavigationObject.endPoi.lng;
    } else {
      poiLat = newNavigationObject.lat;
      poiLng = newNavigationObject.lng;
    }

    // const poiLevelIndex = newNavigationObject.level;
    const poiGisLevelId = newNavigationObject.endPoi.levelId;
    const poiMapAlign = findMapAlignWithGisLevelId(
      latestAllFloorMapAlignRef.current,
      poiGisLevelId,
      [poiLng, poiLat],
    );

    const newCheckpointArray: number[] = [];

    const currentNavigationPercentageMessageDictionary: Record<number, string> =
      {};
    const currentNavigationPercentagePositionDictionary: Record<
      number,
      number[]
    > = {};
    const currentNavigationPercentageTargetDictionary: Record<
      number,
      number[]
    > = {};
    const currentNavigationPercentagePathTypeDictionary: Record<
      number,
      number
    > = {};
    // const currentNavigationPercentageLevelIndexDictionary: Record<
    //   number,
    //   number
    // > = {};
    const currentNavigationPercentageLcMapIdDictionary: Record<number, string> =
      {};

    const currentNavigationLevelShortNameDictionary: Record<string, string> =
      {};

    // let isAddClearMessage = false;

    let isSkipAfterLevelChange = false;
    newNavigationObject.navigation.forEach(function (node, index, array) {
      const thisNodeMapAlign = findMapAlignWithGisLevelId(
        latestAllFloorMapAlignRef.current,
        node.levelId,
        [node.lng, node.lat],
      );
      if (!thisNodeMapAlign) {
        return;
      }
      const modelConfigMap = getModelConfigMapByLcMapId(
        mapSettingRef.current.modelConfig,
        thisNodeMapAlign.lcMapId,
      );
      if (!modelConfigMap) {
        return;
      }

      processedDistance =
        processedDistance > totalDistance ? totalDistance : processedDistance;
      const currentPercentage = processedDistance / totalDistance;
      const addDistance =
        node.distance <= 0 ? FLOOR_CHANGE_DISTANCE : node.distance;
      processedDistance += addDistance;

      // currentNavigationPercentageLevelIndexDictionary[currentPercentage] =
      //   node.level;

      currentNavigationPercentageLcMapIdDictionary[currentPercentage] =
        thisNodeMapAlign.lcMapId;

      if (
        !(modelConfigMap.lcMapId in currentNavigationLevelShortNameDictionary)
      ) {
        currentNavigationLevelShortNameDictionary[modelConfigMap.lcMapId] =
          modelConfigMap.shortName;
      }

      let scaleFactor = SCALE_BASE / thisNodeMapAlign.scale;
      let altitude = modelConfigMap.altitude;

      //console.log("@@ " + thisNodeMapAlign.lcMapId + "--" + altitude + " " + scaleFactor);

      const thisNodeCU = new CoordinateUtil(
        thisNodeMapAlign,
        thisNodeMapAlign.bbox != null,
      );
      let positionXy = thisNodeCU.latLngToXY([node.lng, node.lat]);
      //let positionXy = calculateXy(thisNodeMapAlign, node.lat, node.lng);

      if (mapSettingRef.current.alignmentSetting == "mesh_alignment") {
        positionXy.y *= -1;
      }

      let markerXy;
      if (node.marker != null) {
        let markerXy = thisNodeCU.latLngToXY([
          node.marker.lng,
          node.marker.lat,
        ]);
        if (mapSettingRef.current.alignmentSetting == "mesh_alignment") {
          markerXy.y *= -1;
        }

        // markerXy = calculateXy(
        //   thisNodeMapAlign,
        //   node.marker.lat,
        //   node.marker.lng,
        // );
      }
      let currentType = node.pathType;
      let currentMessage = node.message;

      currentNavigationPercentagePathTypeDictionary[currentPercentage] =
        currentType;

      if (currentPercentage == 0) {
        currentNavigationPercentageMessageDictionary[currentPercentage] = "";
      }

      // if (isAddClearMessage) {
      //   isAddClearMessage = false;
      //   currentNavigationPercentageMessageDictionary[currentPercentage] = "";
      // }

      // if (
      //   index == 0 ||
      //   index == array.length - 1 ||
      //   (currentType != 1 && currentMessage != null)
      // ) {

      // if (isSkipAfterLevelChange) {
      //   //skip Continue ahead message
      //   isSkipAfterLevelChange = false;
      //   console.log("skip " + currentMessage);
      // } else {
      //   if (index == array.length - 1 || currentMessage != null) {
      //     newCheckpointArray.push(currentPercentage);
      //     currentNavigationPercentageMessageDictionary[currentPercentage] =
      //       currentMessage;
      //     if (currentType != 1) {
      //       console.log("add flag skip " + currentType + " " + currentMessage);
      //       isSkipAfterLevelChange = true;
      //     }
      //   }
      // }

      if (isSkipAfterLevelChange) {
        //skip Continue ahead message
        isSkipAfterLevelChange = false;
        console.log("skip " + currentMessage);
        currentNavigationPercentageMessageDictionary[currentPercentage] = "";
      } else {
        if (currentMessage != null) {
          newCheckpointArray.push(currentPercentage);
          currentNavigationPercentageMessageDictionary[currentPercentage] =
            currentMessage;
          if (currentType != 1) {
            console.log("add flag skip " + currentType + " " + currentMessage);
            isSkipAfterLevelChange = true;
          }
        }
      }

      currentNavigationPercentagePositionDictionary[currentPercentage] = [
        -positionXy.x / scaleFactor,
        altitude / scaleFactor,
        -positionXy.y / scaleFactor,
      ];

      if (index < array.length - 1) {
        const nextNode = array[index + 1];
        const nextNodeMapAlign = findMapAlignWithGisLevelId(
          latestAllFloorMapAlignRef.current,
          nextNode.levelId,
          [nextNode.lng, nextNode.lat],
        );

        // if (!nextNodeMapAlign) {
        //   return;
        // }

        const nextNodeScaleFactor = SCALE_BASE / nextNodeMapAlign.scale;

        const nextNodeModelConfigMap = getModelConfigMapByLcMapId(
          mapSettingRef.current.modelConfig,
          nextNodeMapAlign.lcMapId,
        );
        if (!nextNodeModelConfigMap) {
          return;
        }

        const nextNodeCU = new CoordinateUtil(
          nextNodeMapAlign,
          nextNodeMapAlign.bbox != null,
        );
        let nextNodePositionXy = nextNodeCU.latLngToXY([
          nextNode.lng,
          nextNode.lat,
        ]);

        if (mapSettingRef.current.alignmentSetting == "mesh_alignment") {
          nextNodePositionXy.y *= -1;
        }
        // let nextNodePositionXy = calculateXy(
        //   nextNodeMapAlign,
        //   nextNode.lat,
        //   nextNode.lng,
        // );

        let nextNodeMarkerXy;
        if (nextNode.marker != null) {
          let nextNodeMarkerXy = nextNodeCU.latLngToXY([
            nextNode.marker.lng,
            nextNode.marker.lat,
          ]);
          if (mapSettingRef.current.alignmentSetting == "mesh_alignment") {
            nextNodeMarkerXy.y *= -1;
          }
          // nextNodeMarkerXy = calculateXy(
          //   nextNodeMapAlign,
          //   nextNode.marker.lat,
          //   nextNode.marker.lng,
          // );
        }
        if (nextNodeMarkerXy != null) {
          currentNavigationPercentageTargetDictionary[currentPercentage] = [
            -nextNodeMarkerXy.x / nextNodeScaleFactor,
            altitude / scaleFactor,
            -nextNodeMarkerXy.y / nextNodeScaleFactor,
          ];
        } else {
          currentNavigationPercentageTargetDictionary[currentPercentage] = [
            -nextNodePositionXy.x / nextNodeScaleFactor,
            altitude / scaleFactor,
            -nextNodePositionXy.y / nextNodeScaleFactor,
          ];
        }
      } else {
        const poiCU = new CoordinateUtil(poiMapAlign, poiMapAlign.bbox != null);
        let poiXy = poiCU.latLngToXY([poiLng, poiLat]);
        if (mapSettingRef.current.alignmentSetting == "mesh_alignment") {
          poiXy.y *= -1;
        }
        //let poiXy = calculateXy(poiMapAlign, poiLat, poiLng);

        // const poiModelConfigMap = getModelConfigMapByLcMapId(mapSettingRef.current.modelConfig,poiMapAlign.lcMapId);
        // let poiAltitude = poiModelConfigMap.altitude;
        currentNavigationPercentageTargetDictionary[currentPercentage] = [
          -poiXy.x / scaleFactor,
          // poiAltitude / mapSettingRef.current.modelConfig.scaleFactor,
          altitude / scaleFactor,
          -poiXy.y / scaleFactor,
        ];
      }
    });

    latestNavigationPercentageMessageDictionary.current =
      currentNavigationPercentageMessageDictionary;
    latestNavigationPercentagePositionDictionary.current =
      currentNavigationPercentagePositionDictionary;
    latestNavigationPercentageTargetDictionary.current =
      currentNavigationPercentageTargetDictionary;
    latestNavigationPercentagePathTypeDictionary.current =
      currentNavigationPercentagePathTypeDictionary;

    // latestNavigationPercentageLevelIndexDictionary.current =
    //   currentNavigationPercentageLevelIndexDictionary;

    latestNavigationPercentageLcMapIdDictionary.current =
      currentNavigationPercentageLcMapIdDictionary;
    latestNavigationLevelShortNameDictionaryRef.current =
      currentNavigationLevelShortNameDictionary;

    setFullDistance(newNavigationObject.distance);
    setFullDuration(newNavigationObject.duration);
    setNavigationCheckpoint(newCheckpointArray);
    setNavigationPercentagePositionDictionary(
      currentNavigationPercentagePositionDictionary,
    );
    resetSlider();
    resetPosition();
  }

  function resetPosition() {
    console.log("reset camera position");
    // setCameraMode(1);
    updateNavigation(0, -1);
  }

  function resetSlider() {
    console.log("reset slider");
    setNavigationMessage("");
    setProgress(0);
  }

  const DebugKeyListener = () => {
    useEffect(() => {
      const handleSpacePress = (event: KeyboardEvent) => {
        // if (event.key === '1') {
        //   setIsShowTopViewNavigation(true);
        // }
      };
      window.addEventListener("keydown", handleSpacePress);
      return () => {
        window.removeEventListener("keydown", handleSpacePress);
      };
    }, []);
    return <></>;
  };

  const LoadingMask = () => {
    const isLoading = useNavigationStore((state) => state.isLoading);
    useEffect(() => {
      console.log("isLoading: " + isLoading);
      if (isLoading) {
        stopAutoPlay();
      }
    }, [isLoading]);
    return isLoading ? (
      <div className="fixed inset-0 z-[60] flex items-center justify-center">
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-80 "></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const DataController = () => {
    const navData = useNavigationStore((state) => state.navData);
    useEffect(() => {
      console.log("navData changed");
      if (navData == null) {
        console.log("NO nav DATA");
        backToHome();
      } else {
        latestNavigationDataRef.current = navData;

        const isNavigationHasChinese = hasChinese(navData);
        isNavigationHasChineseRef.current = isNavigationHasChinese;
        let venueId;
        if (navData.nav[0].startingPoi) {
          venueId = navData.nav[0].startingPoi.venueId ?? 0;
        } else {
          venueId = navData.nav[0].venueId ?? 0;
        }
        setCurrentVenueId(venueId);
        const venueShortName = getVenueShortNameById(venueId).toLowerCase();
        setCurrentVenue(venueShortName);

        const mapSetting = getVenueMapInformationByVenueId(venueId);
        setMapSettingState(mapSetting);
        mapSettingRef.current = mapSetting;

        latestAllFloorMapAlignRef.current = mapSetting.floorAlignment;

        // mapSetting.modelConfig.floor.forEach((floor) => {
        //   if (floor.cameras) {
        //     //console.log(floor.cameras);
        //     let floorCameras: pc.Vec3[] = [];
        //     floor.cameras.forEach((cameraPosition) => {
        //       //console.log(cameraPosition.length);
        //       if (cameraPosition.length == 3) {
        //         floorCameras.push(
        //           new pc.Vec3(
        //             Number(cameraPosition[0]) /
        //               mapSetting.modelConfig.scaleFactor,
        //             Number(cameraPosition[1]) /
        //               mapSetting.modelConfig.scaleFactor,
        //             Number(cameraPosition[2]) /
        //               mapSetting.modelConfig.scaleFactor,
        //           ),
        //         );
        //       }
        //     });
        //     navigationFloorCamerasRef.current[floor.lcMapId.toString()] =
        //       floorCameras;
        //   }
        // });

        updatePath();

        if (mapSetting.modelConfig && !mapSetting.modelConfig?.splat) {
          console.log("skip 3dGS !!!!");
          setSceneAnimationState("orbit");
        }
      }
      return () => {
        stopAutoPlay();
        console.log("Component is unmounting");
      };
    }, [navData]);

    const progress = useNavigationStore((state) => state.progress);

    useEffect(() => {
      if (progress >= 0) {
        latestProgressRef.current = progress;
        if (progress >= previousProgressRef.current) {
          playDirectionRef.current = "forward";
        } else {
          playDirectionRef.current = "backward";
        }
        previousProgressRef.current = progress;
        updateNavigation(latestProgressRef.current);
      }
      // isCameraUpdating.current = true;
    }, [progress]);

    const fullDistance = useNavigationStore((state) => state.fullDistance);
    const fullDuration = useNavigationStore((state) => state.fullDuration);

    useEffect(() => {
      latestFullDistance.current = fullDistance;
      latestFullDuration.current = fullDuration;
    }, [fullDistance, fullDuration]);

    const startAutoPlayData = useNavigationStore(
      (state) => state.startAutoPlayData,
    );
    const resetStartAutoPlayDelay = useNavigationStore(
      (state) => state.resetStartAutoPlayDelay,
    );
    const stopAutoPlayData = useNavigationStore(
      (state) => state.stopAutoPlayData,
    );

    const cameraMode = useNavigationStore((state) => state.cameraMode);
    useEffect(() => {
      latestCameraModeRef.current = cameraMode;
    }, [cameraMode]);

    useEffect(() => {
      if (startAutoPlayData.delay < 0) {
        return;
      }
      if (!isFirstAutoPlayedRef.current) {
        //setCameraMode(0);
        isFirstAutoPlayedRef.current = true;
      }
      console.log("startAutoPlayData.delay=", startAutoPlayData.delay);
      resumeAutoPlay(startAutoPlayData.delay);
      resetStartAutoPlayDelay();
    }, [startAutoPlayData]);

    useEffect(() => {
      console.log("stopAutoPlayData=", stopAutoPlayData);
      if (stopAutoPlayData < 0) {
        return;
      }
      stopAutoPlay();
    }, [stopAutoPlayData]);

    const xRayMode = useNavigationStore((state) => state.xRayMode);
    useEffect(() => {
      latestXrayModeRef.current = xRayMode;
      const opacity = xRayMode === 2 ? 0.05 : 1.0;
      for (const [key, eachSplat] of Object.entries(gsplatAllRef.current)) {
        if (eachSplat) {
          // console.log(eachSplat);
          if (
            eachSplat.gsplat == null ||
            eachSplat.gsplat.setWorkBufferModifier == null
          ) {
            return;
          }
          eachSplat.gsplat.setWorkBufferModifier({
            glsl: `
              void modifySplatCenter(inout vec3 center) {}
              void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {}
              void modifySplatColor(vec3 center, inout vec4 color) { color.a *= ${opacity.toFixed(1)}; }
            `,
          });
          // console.log(eachSplat);
          if (eachSplat.enabled) {
            eachSplat.enabled = false;
            setTimeout(() => {
              eachSplat.enabled = true;
            }, 1);
          }
        }
      }
      if (xRayMode == 2) {
        setCameraMode(1);
      }
    }, [xRayMode]);

    const annotationMode = useNavigationStore((state) => state.annotationMode);
    useEffect(() => {
      latestAnnotationModeRef.current = annotationMode;
    }, [annotationMode]);

    const isLoading = useNavigationStore((state) => state.isLoading);
    const isInterrupt = useNavigationStore((state) => state.isInterrupt);
    const setInterrupt = useNavigationStore((state) => state.setInterrupt);
    const {
      playAudio,
      muteAudio,
      unmuteAudio,
      pauseAudio,
      resumeAudio,
      stopAudio,
    } = useAudioPlayer();
    // const { cancelReading } = useMessagePlayer();
    useEffect(() => {
      console.log("isInterrupt: " + isInterrupt + ", isLoading: " + isLoading);
      if (isInterrupt) {
        if (isLoading) {
          stopAutoPlay();
          resetPosition();
          resetSlider();
        }
        // cancelReading();
        console.log("isInterrupt stopAudio ");
        stopAudio();
        setInterrupt(false);
      }
    }, [isInterrupt]);

    const sceneAnimationState = useNavigationStore(
      (state) => state.sceneAnimationState,
    );
    useEffect(() => {
      sceneAnimationStateRef.current = sceneAnimationState;
    }, [sceneAnimationState]);

    return <></>;
  };

  const MapBlockingScreen = () => {
    const isShowNavigationContinueButton = useNavigationStore(
      (state) => state.isShowNavigationContinueButton,
    );
    const isShowNavigationRestartButton = useNavigationStore(
      (state) => state.isShowNavigationRestartButton,
    );
    const [mapBlockingScreenOpacity, setMapBlockingScreenOpacity] = useState(0);
    const [lastestTypeState, setLastestTypeState] = useState<string>("");
    const [isShowNoModelData, setIsShowNoModelData] = useState<string>("");

    const progress = useNavigationStore((state) => state.progress);
    useEffect(() => {
      const pathType = getStartValueArray(
        latestNavigationPercentagePathTypeDictionary.current,
        progress,
      );
      const previousPathType = getPreviousNumber(
        latestNavigationPercentagePathTypeDictionary.current,
        progress,
      );
      const nextPathType = getEndValueArray(
        latestNavigationPercentagePathTypeDictionary.current,
        progress,
      );
      const nextNextPathType = getNextEndValueArray(
        latestNavigationPercentagePathTypeDictionary.current,
        progress,
      );
      const currentLcMapId = getStartValueArray(
        latestNavigationPercentageLcMapIdDictionary.current,
        progress,
      );
      const nextNodeLcMapId = getEndValueArray(
        latestNavigationPercentageLcMapIdDictionary.current,
        progress,
      );

      // if (
      //   (isLift(pathType) ||
      //     isEscalator(pathType) ||
      //     isStair(pathType) ||
      //     isLift(previousPathType) ||
      //     isEscalator(previousPathType || isStair(previousPathType))) &&
      //   !isShowNavigationContinueButton &&
      //   !isShowNavigationRestartButton
      // ) {
      //   if (isLift(pathType) || isEscalator(pathType) || isStair(pathType)) {
      //     setLastestTypeState(pathType);
      //   } else if (
      //     isLift(previousPathType) ||
      //     isEscalator(previousPathType) ||
      //     isStair(previousPathType)
      //   ) {
      //     setLastestTypeState(previousPathType);
      //   }
      //   setMapBlockingScreenOpacity(1);
      //   isNavigationMapChangingRef.current = true;
      // } else {
      //   setMapBlockingScreenOpacity(0);
      //   isNavigationMapChangingRef.current = false;
      // }

      let isShowingMapBlur = false;
      if (currentLcMapId != nextNodeLcMapId) {
        isShowingMapBlur = true;
        // console.log("change level!!!! " + lastestTypeState);
      }

      if (
        currentModelConfigMapRef.current != null &&
        currentModelConfigMapRef.current.isNotReady != null &&
        !isShowNavigationContinueButton &&
        !isShowNavigationRestartButton
      ) {
        isShowingMapBlur = true;
        setIsShowNoModelData(true);
      } else {
        setIsShowNoModelData(false);
      }

      // if (
      //   mapSettingState &&
      //   mapSettingState.modelConfig &&
      //   mapSettingState.modelConfig.splat
      // ) {
      //   if (
      //     mapSettingState.modelConfig.splat.mode == "floorLod" &&
      //     currentModelConfigMapRef.current.lod == null
      //   ) {
      //     isShowingMapBlur = true;
      //     setIsShowNoModelData(true);
      //     latestIsNoModelDataRef.current = true;
      //   } else {
      //     setIsShowNoModelData(false);
      //     latestIsNoModelDataRef.current = false;
      //   }
      // }

      if (
        (isLift(pathType) || isEscalator(pathType) || isStair(pathType)) &&
        !isShowNavigationContinueButton &&
        !isShowNavigationRestartButton
      ) {
        setLastestTypeState(pathType);
        if (playDirectionRef.current == "forward") {
          isShowingMapBlur = true;
        }
      } else if (
        (isLift(previousPathType) ||
          isEscalator(previousPathType) ||
          isStair(previousPathType)) &&
        !isShowNavigationContinueButton &&
        !isShowNavigationRestartButton
      ) {
        setLastestTypeState(previousPathType);
        if (playDirectionRef.current == "backward") {
          isShowingMapBlur = true;
        }
      } else {
        setLastestTypeState(1);
      }

      setMapBlockingScreenOpacity(isShowingMapBlur ? 1 : 0);
      isNavigationMapChangingRef.current = isShowingMapBlur;
    }, [
      progress,
      isShowNavigationContinueButton,
      isShowNavigationRestartButton,
    ]);

    return (
      <div>
        <div
          className="w-full h-full fixed top-0 left-0 pointer-events-none transition-opacity"
          style={{ opacity: mapBlockingScreenOpacity }}
          // style={{ opacity: 1 }}
        >
          <div className="frosted-fullscreen flex flex-col items-center justify-center">
            {lastestTypeState != null && lastestTypeState != 1 ? (
              <Image
                src={"/assets/icon_nav_" + lastestTypeState + "_black.png"}
                width={100}
                height={100}
              />
            ) : (
              <></>
            )}
            {isShowNoModelData && lastestTypeState == 1 ? (
              <div className="flex flex-col items-center justify-center">
                <Text
                  className="text-500 primary-text-dark"
                  text={"3D data for this area is coming soon!"}
                />
                <Text
                  className="text-500 primary-text-dark"
                  text={"該區域 3D 模型建置中，敬請期待！"}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    );
  };

  const NavigationAutoPlayController = () => {
    const app = useApp();

    let eachProgress = -1;
    let _newProgress = 0;
    const releaseDelay = 2000;
    let _currentMouse = 0;
    let _currentTouch = 0;
    let isSplatLoading = false;

    const handleUpdate = useCallback((dt: number) => {
      let isMouseUpdated =
        _currentMouse != cameraScriptRef.current._state.mouse[0];
      _currentMouse = cameraScriptRef.current._state.mouse[0];
      let isTouchUpdated =
        _currentTouch != cameraScriptRef.current._state.touches;
      _currentTouch = cameraScriptRef.current._state.touches;

      if (isMouseUpdated) {
        if (_currentMouse == 1) {
          console.log("mouse drag");
          stopAutoPlay();
          if (isMouseDraggingTimeoutRef.current != null) {
            clearTimeout(isMouseDraggingTimeoutRef.current);
            isMouseDraggingTimeoutRef.current = null;
          }
          console.log("TRACK NAV_PAGE_INTERACTED", navEventData);
          trackGAEvent(EVENT.NAV_PAGE_3D_INTERACTION, {
            mode: "navigation",
            type: "mouse_drag",
            navToken: navEventData.get("navToken") ?? "",
            referrer: navEventData.get("referrer") ?? "",
          });
          trackEvent(AMPLITUDE_EVENT.NAV_PAGE_INTERACTED, {
            mode: "navigation",
            type: "mouse_drag",
            navToken: navEventData.get("navToken") ?? "",
            referrer: navEventData.get("referrer") ?? "",
          });
          isMouseDraggingRef.current = true;
        } else {
          console.log("mouse release");
          if (isMouseDraggingTimeoutRef.current != null) {
            clearTimeout(isMouseDraggingTimeoutRef.current);
            isMouseDraggingTimeoutRef.current = null;
          }
          isMouseDraggingTimeoutRef.current = setTimeout(() => {
            isMouseDraggingRef.current = false;
            if (!isWaitingUserContinue.current) {
              resumeAutoPlay(0);
            }
          }, releaseDelay);
        }
      }

      if (isTouchUpdated) {
        if (_currentTouch >= 1) {
          console.log("touch drag");
          stopAutoPlay();
          if (isTouchDraggingTimeoutRef.current != null) {
            clearTimeout(isTouchDraggingTimeoutRef.current);
            isTouchDraggingTimeoutRef.current = null;
          }
          isTouchDraggingRef.current = true;
          console.log("TRACK NAV_PAGE_INTERACTED", navEventData);
          trackGAEvent(EVENT.NAV_PAGE_3D_INTERACTION, {
            mode: "navigation",
            type: "touch_drag",
            navToken: navEventData.get("navToken") ?? "",
            referrer: navEventData.get("referrer") ?? "",
          });
          trackEvent(AMPLITUDE_EVENT.NAV_PAGE_INTERACTED, {
            mode: "navigation",
            type: "touch_drag",
            navToken: navEventData.get("navToken") ?? "",
            referrer: navEventData.get("referrer") ?? "",
          });
        } else {
          console.log("touch release");
          if (isTouchDraggingTimeoutRef.current != null) {
            clearTimeout(isTouchDraggingTimeoutRef.current);
            isTouchDraggingTimeoutRef.current = null;
          }
          isTouchDraggingTimeoutRef.current = setTimeout(() => {
            isTouchDraggingRef.current = false;
            if (!isWaitingUserContinue.current) {
              resumeAutoPlay(0);
            }
          }, releaseDelay);
        }
      }

      // if (duration == -1) {
      //   duration = latestFullDuration.current;
      // }
      if (isAutoPlayingRef.current) {
        if (isNavigationReadyChangeMapRef.current) {
          eachProgress =
            (dt / latestFullDistance.current) * (autoPlaySpeedRef.current * 10);
        } else if (currentModelConfigMapRef.current?.isNotReady != null) {
          eachProgress =
            (dt / latestFullDistance.current) * (autoPlaySpeedRef.current * 20);
        } else if (isSplatLoading && isNavigationMapChangingRef.current) {
          eachProgress =
            (dt / latestFullDuration.current) *
            (autoPlaySpeedRef.current * 0.05);
        } else if (isSplatLoading) {
          eachProgress =
            (dt / latestFullDistance.current) * autoPlaySpeedRef.current;
        } else {
          if (sceneAnimationStateRef.current == "preview") {
            eachProgress =
              (dt / latestFullDistance.current) *
              (autoPlaySpeedRef.current * 2);
          } else {
            eachProgress =
              (dt / latestFullDistance.current) * autoPlaySpeedRef.current;
          }
        }
        _newProgress =
          latestProgressRef.current + eachProgress > 1
            ? 1
            : latestProgressRef.current + eachProgress;
        setProgress(_newProgress);
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return <></>;
  };

  const cleanup = (app, gsplatEntity) => {
    const cleanup = installCameraNearFar(
      app,
      gsplatEntity,
      hiddenNearRef.current,
      hiddenFarRef.current,
    );
    return cleanup;
  };

  const FloorMeshContainer = () => {
    const baseUrl = getBaseUrl();
    const floorMeshPosition = mapSettingState.modelConfig.floorMeshPosition;
    const floorMeshUrl =
      baseUrl +
      mapSettingState.modelConfig!.folderPath +
      mapSettingState.modelConfig.floorMesh;
    return floorMeshUrl != "" ? (
      <FloorMeshComponent
        floorMeshUrl={floorMeshUrl}
        floorMeshPosition={[
          floorMeshPosition[0] / mapSettingState.modelConfig.scaleFactor,
          floorMeshPosition[1] / mapSettingState.modelConfig.scaleFactor,
          floorMeshPosition[2] / mapSettingState.modelConfig.scaleFactor,
        ]}
        floorMeshScale={[
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
        ]}
      />
    ) : (
      <></>
    );
  };

  const MainCamera = () => {
    const app = useApp();
    const cameraRef = useRef();
    let _localProgress;
    let _localCameraMode;

    let previousRotationY = 0;

    let finalCameraPosition = new pc.Vec3(0, 0, 0);
    let finalCameraLookingPosition = new pc.Vec3(0, 0, 0);

    let lostWallRaycastCount = 0;
    let isForceFirstPersonCamera = false;
    let previousWallBlockingCameraDistance = 0;

    let orbitAnimationTime = 0;
    const orbitDuration = 5;

    const checkWallBlockingCameraDistance = (expectedCameraPosition) => {
      const rigidbodySystem = app.systems.rigidbody;
      if (!rigidbodySystem || !rigidbodySystem.dynamicsWorld) {
        return;
      }
      const currentPosition = mainObjectEntityRef.current.getPosition().clone();
      const from = new pc.Vec3(
        currentPosition.x,
        currentPosition.y,
        currentPosition.z,
      );
      const to = getNewFrontPosition(
        currentPosition,
        expectedCameraPosition,
        100,
      );
      const hit = rigidbodySystem.raycastFirst(from, to);
      if (hit && hit.entity.name.includes("obstacle")) {
        const distance = currentPosition.z - hit.point.z;
        return Math.abs(distance);
      } else {
        return null;
      }
    };

    const handleUpdate = useCallback((dt: number) => {
      if (cameraScriptRef.current == null) {
        return;
      }
      let isProgressUpdated = false;
      if (_localProgress != latestProgressRef.current) {
        _localProgress = latestProgressRef.current;
        isProgressUpdated = true;
      }
      let isCameraModeUpdated = false;
      if (_localCameraMode != latestCameraModeRef.current) {
        _localCameraMode = latestCameraModeRef.current;
        isCameraModeUpdated = true;
      }

      if (sceneAnimationStateRef.current == "init") {
        isDisplayEnteringMaskRef.current = true;
        isDisplayStartEndPointDivRef.current = true;
        isDisplayStartEndPointFirstRef.current = true;
        isDisplayAvatarRef.current = true;
        const offsetLocal = new pc.Vec3(0, 0, -3);
        const offsetWorld = firstPersonCameraEntityRef.current
          .getRotation()
          .transformVector(offsetLocal);
        const newPos = firstPersonCameraEntityRef.current
          .getPosition()
          .clone()
          .add(offsetWorld);
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPos,
        );
      } else if (sceneAnimationStateRef.current == "orbit") {
        isDisplayAvatarRef.current = true;
        isDisplayEnteringMaskRef.current = false;
        if (orbitAnimationTime <= 0.5) {
          isDisplayStartEndPointFirstRef.current = false;
          isDisplayStartEndPointSecondRef.current = true;
        } else if (orbitAnimationTime <= 1) {
          isDisplayStartEndPointSecondRef.current = true;
          isDisplayStartEndPointStartRef.current = true;
        } else if (orbitAnimationTime <= 2) {
          isDisplayStartEndPointSecondRef.current = false;
          isDisplayStartEndPointThirdRef.current = true;
          isDisplayStartEndPointEndRef.current = true;
        } else if (orbitAnimationTime > 3.5) {
          isDisplayStartEndPointFirstRef.current = false;
          isDisplayStartEndPointSecondRef.current = false;
          isDisplayStartEndPointThirdRef.current = false;
          isDisplayStartEndPointStartRef.current = false;
          isDisplayStartEndPointEndRef.current = false;
        }

        if (orbitAnimationTime >= orbitDuration) {
          cameraScriptRef.current.reset(
            mainObjectEntityRef.current.getPosition(),
            thirdPersonCameraEntityRef.current.getPosition(),
          );
          setSceneAnimationState("preview");
          setIsDisplaySkipPreview(true);
          // isDisplayAvatarRef.current = false;
          // isEnableDragRef.current = true;
          setCameraMode(1);
          isDisplayStartEndPointDivRef.current = false;
          // setIsDisplayUI(true);
          setLoading(false);
          startAutoPlayDelay(0);
          //TEMP
          // for (const [key, eachSplat] of Object.entries(gsplatAllRef.current)) {
          //   eachSplat.removeComponent("script");
          //   eachSplat.addComponent("script");
          //   cleanup(app, eachSplat);
          // }
          return;
        }
        orbitAnimationTime += dt;
        const t = Math.min(orbitAnimationTime / orbitDuration, 1);
        const newCameraPosition = interpolateVector3(initCameraMovement, t);
        const offsetLocal = new pc.Vec3(
          -newCameraPosition[0],
          newCameraPosition[1],
          -newCameraPosition[2],
        );
        const offsetWorld = firstPersonCameraEntityRef.current
          .getRotation()
          .transformVector(offsetLocal);
        const newPos = firstPersonCameraEntityRef.current
          .getPosition()
          .clone()
          .add(offsetWorld);
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPos,
        );
      } else if (sceneAnimationStateRef.current == "preview") {
        const mainObject = mainObjectEntityRef.current;
        const mainObjectPosition = mainObject.getPosition().clone();
        if (isProgressUpdated) {
          finalCameraLookingPosition = mainObjectPosition.clone();
          finalCameraPosition =
            thirdPersonCameraEntityRef.current.getPosition();

          let wallBlockingCameraDistance =
            checkWallBlockingCameraDistance(finalCameraPosition);
          if (
            wallBlockingCameraDistance != null &&
            wallBlockingCameraDistance < THIRD_PERSION_DISTANCE
          ) {
            isForceFirstPersonCamera = true;
            previousWallBlockingCameraDistance = wallBlockingCameraDistance;
          } else {
            if (isForceFirstPersonCamera) {
              lostWallRaycastCount += 1;
              wallBlockingCameraDistance = previousWallBlockingCameraDistance;
            }
            if (lostWallRaycastCount > 100) {
              lostWallRaycastCount = 0;
              isForceFirstPersonCamera = false;
            }
          }
          if (isForceFirstPersonCamera) {
            const adjustDistance =
              wallBlockingCameraDistance - 0.4 < 0
                ? 0
                : wallBlockingCameraDistance - 0.4;
            const adjustedCameraPosition = getNewFrontPosition(
              firstPersonCameraEntityRef.current.getPosition(),
              thirdPersonCameraEntityRef.current.getPosition(),
              adjustDistance,
            );
            finalCameraPosition = adjustedCameraPosition;
          }

          cameraScriptRef.current.reset(
            finalCameraLookingPosition,
            finalCameraPosition,
          );
          latestCameraPositionRef.current = finalCameraPosition;
          const cameraAngle = getYAngleDegree(
            firstPersonCameraEntityRef.current.getPosition(),
            navigationObjectDesiredPositionRef.current,
          );
          setNavigationAngle(cameraAngle);
          setNavigationCameraPosition(finalCameraPosition);
          setNavigationCameraLookingPosition(finalCameraLookingPosition);
        }
      } else if (sceneAnimationStateRef.current == "stepByStep") {
        const mainObject = mainObjectEntityRef.current;
        const mainObjectPosition = mainObject.getPosition().clone();

        if (
          isProgressUpdated ||
          isCameraModeUpdated ||
          (isMouseDraggingRef.current == false &&
            isTouchDraggingRef.current == false)
        ) {
          if (_localCameraMode == 0) {
            const forward = mainObject.forward.clone().mulScalar(-0.1);
            finalCameraLookingPosition = mainObjectPosition.clone();
            finalCameraPosition = mainObjectPosition.add(forward);
          } else {
            finalCameraLookingPosition = mainObjectPosition.clone();
            finalCameraPosition =
              thirdPersonCameraEntityRef.current.getPosition();
          }

          cameraScriptRef.current.reset(
            finalCameraLookingPosition,
            finalCameraPosition,
          );

          latestCameraPositionRef.current = finalCameraPosition;
          const cameraAngle = getYAngleDegree(
            firstPersonCameraEntityRef.current.getPosition(),
            navigationObjectDesiredPositionRef.current,
          );

          setNavigationAngle(cameraAngle);
          setNavigationCameraPosition(finalCameraPosition);
          setNavigationCameraLookingPosition(finalCameraLookingPosition);
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity name="MainCamera">
        <Camera />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -0.5]}></Entity>
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();
    const avatarEntityRef = useRef(null);
    const cameraRef = useRef();
    let previousRotationY = 0;
    const previousHit = useRef();

    const adjustPositionWithRaycast = () => {
      const rigidbodySystem = app.systems.rigidbody;
      if (!rigidbodySystem) {
        return;
      }
      if (isNavigationMapChangingRef.current) {
        previousHit.current = null;
      }
      const currentPosition = mainObjectEntityRef.current.getPosition().clone();
      const from = new pc.Vec3(
        currentPosition.x,
        currentPosition.y + 100,
        currentPosition.z,
      );
      const to = new pc.Vec3(
        currentPosition.x,
        currentPosition.y - 100,
        currentPosition.z,
      );
      const hit = rigidbodySystem.raycastFirst(from, to);
      if (hit && hit.entity.name.includes("ground")) {
        const verticalDistance = currentPosition.y - hit.point.y;
        if (verticalDistance < 20) {
          const adjustedPosition = new pc.Vec3(
            hit.point.x,
            hit.point.y + 1,
            hit.point.z,
          );
          mainObjectEntityRef.current.setPosition(adjustedPosition);
          previousHit.current = hit;
        }
      } else if (previousHit.current) {
        const adjustedPosition = new pc.Vec3(
          currentPosition.x,
          previousHit.current.point.y + 1,
          currentPosition.z,
        );
        mainObjectEntityRef.current.setPosition(adjustedPosition);
      }
    };

    const handleUpdate = useCallback((dt: number) => {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      const distance = vec3Distance(
        mainObjectEntityRef.current.localPosition,
        navigationObjectDesiredPositionRef.current,
      );

      const lerpPosition = mainObjectEntityRef.current.getPosition();
      lerpPosition.lerp(
        lerpPosition,
        navigationObjectDesiredPositionRef.current,
        dt * 5,
      );
      mainObjectEntityRef.current.setPosition(lerpPosition);
      if (
        sceneAnimationStateRef.current == "orbit" ||
        sceneAnimationStateRef.current == "preview" ||
        sceneAnimationStateRef.current == "stepByStep"
      ) {
        adjustPositionWithRaycast();
      }

      const targetRotation = calculateLookAtRotation(
        navigationObjectDesiredPositionRef.current,
        navigationObjectDesiredTargetRef.current,
      );

      // if (!isNavigationMapChangingRef.current) {

      // }
      const lerpRotation = mainObjectEntityRef.current.getRotation();
      lerpRotation.lerp(lerpRotation, targetRotation, dt * 5);
      mainObjectEntityRef.current.setRotation(lerpRotation);

      if (avatarEntityRef.current) {
        avatarEntityRef.current.enabled =
          (sceneAnimationStateRef.current == "stepByStep" &&
            latestCameraModeRef.current == 1 &&
            latestXrayModeRef.current != 2) ||
          isDisplayAvatarRef.current;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity ref={avatarEntityRef}>
          {mapSettingState ? (
            <RobotAvatar
              avatarUrl={mapSettingState.avatar}
              isFloating={mapSettingState.avatarIsFloating}
            />
          ) : (
            <></>
          )}
        </Entity>
        {/*<NavigationAvatar />*/}
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.5]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.3, THIRD_PERSION_DISTANCE]}
        ></Entity>
      </Entity>
    );
  };

  const WalkPathsContainer = () => {
    const app = useApp();
    const isPointsSetup = useRef<boolean>(false);
    const [points, setPoints] = useState<number[][] | null>(null);

    const handleUpdate = useCallback((dt: number) => {
      if (
        !isPointsSetup.current &&
        latestNavigationPercentagePositionDictionary.current
      ) {
        let points = [];
        const entries = Object.entries(
          latestNavigationPercentagePositionDictionary.current,
        );
        for (let i = 0; i < entries.length; i++) {
          points.push(entries[i][1]);
        }
        setPoints([...points]);
        isPointsSetup.current = true;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return points != null ? <WalkPaths points={points} /> : <></>;
  };

  const WalkPaths = ({ points }: { points: number[][] }) => {
    const segments = points.slice(0, -1).map((start, i) => {
      const end = points[i + 1];
      const length = Math.hypot(
        end[0] - start[0],
        end[1] - start[1],
        end[2] - start[2],
      );
      return (
        <Fragment key={i}>
          <EachWalkPath
            start={start}
            end={end}
            length={length}
            pathIndex={i + 1}
            pathLength={points.length - 1}
          />
        </Fragment>
      );
    });
    return (
      <>
        {segments}
        <ExtraWalkPath points={points} />
      </>
    );
  };

  const ExtraWalkPath = ({ points }: { points: number[][] }) => {
    const app = useApp();
    let _localNavigationCameraPosition;
    let isCameraNavigationPositionUpdated;

    const _startPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const _endPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

    const entityRef = useRef();
    const innerBoxRef = useRef();
    const outerBoxRef = useRef();
    const outerBox2Ref = useRef();
    const outerBox3Ref = useRef();

    useEffect(() => {
      const innerMeshInstance = innerBoxRef.current.render.meshInstances[0];
      const innerMaterial = innerMeshInstance.material;
      const newInnerMaterial = innerMaterial.clone();
      innerMeshInstance.material = newInnerMaterial;
      newInnerMaterial.emissiveMap = newInnerMaterial.diffuseMap;
      newInnerMaterial.emissiveIntensity = 2.5;
      newInnerMaterial.useLighting = false;
      newInnerMaterial.useSkybox = false;
      newInnerMaterial.emissive.set(1, 1, 0.176);
      // newInnerMaterial.diffuse.set(0.663, 0.663, 0.027);
      newInnerMaterial.blendType = pc.BLEND_NONE;

      const outerRefs = [outerBoxRef, outerBox2Ref, outerBox3Ref];
      const opacities = [0.5, 0.2, 0.1];

      outerRefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;

          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(0.996, 0.184, 0.016);
          material.useLighting = false;
          material.useSkybox = false;
          material.blendType = pc.BLEND_ADDITIVEALPHA;
          material.opacity = opacities[index];
          material.update();
        }
      });
    }, []);

    const handleUpdate = useCallback((dt: number) => {
      if (
        entityRef.current == null ||
        latestProgressRef.current == 0 ||
        latestProgressRef.current >= 0.999
      ) {
        entityRef.current.enabled = false;
        return;
      }
      const currentPosition = getInterpolatedNumberArray(
        latestNavigationPercentagePositionDictionary.current,
        latestProgressRef.current,
      );

      const startPosition = getFloorNumberArray(
        latestNavigationPercentagePositionDictionary.current,
        latestProgressRef.current,
      );
      _startPositionRef.current.set(
        startPosition[0],
        startPosition[1],
        startPosition[2],
      );
      _endPositionRef.current.set(
        currentPosition[0],
        currentPosition[1],
        currentPosition[2],
      );
      const length = Math.hypot(
        _endPositionRef.current.x - _startPositionRef.current.x,
        _endPositionRef.current.y - _startPositionRef.current.y,
        _endPositionRef.current.z - _startPositionRef.current.z,
      );
      entityRef.current.setPosition(_startPositionRef.current);
      entityRef.current.lookAt(_endPositionRef.current);
      if (_startPositionRef.current.y == _endPositionRef.current.y) {
        entityRef.current.setLocalScale(0.05, 0.05, length);
        entityRef.current.translateLocal(0, -0.5, -length / 2);
      } else {
        entityRef.current.setLocalScale(0.05, 0.05, length + 0.075);
        entityRef.current.translateLocal(0, -0.45, -length / 2 + 0.2);
      }
      entityRef.current.enabled =
        latestXrayModeRef.current == 2 && latestCameraModeRef.current == 1;
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={entityRef}>
        <Entity ref={innerBoxRef} scale={[1, 1, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBoxRef} scale={[1.2, 1.2, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox2Ref} scale={[1.4, 1.4, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox3Ref} scale={[1.6, 1.6, 1]}>
          <Render type="box" />
        </Entity>
      </Entity>
    );
  };

  const EachWalkPath = ({ start, end, length, pathIndex, pathLength }) => {
    const app = useApp();
    const entityRef = useRef();
    const innerBoxRef = useRef();
    const outerBoxRef = useRef();
    const outerBox2Ref = useRef();
    const outerBox3Ref = useRef();

    const pathCorrespondingPercentage = useRef<number>(-1);

    useEffect(() => {
      const innerMeshInstance = innerBoxRef.current.render.meshInstances[0];
      const innerMaterial = innerMeshInstance.material;
      const newInnerMaterial = innerMaterial.clone();
      innerMeshInstance.material = newInnerMaterial;
      newInnerMaterial.emissiveMap = newInnerMaterial.diffuseMap;
      newInnerMaterial.emissiveIntensity = 2.5;
      newInnerMaterial.useLighting = false;
      newInnerMaterial.useSkybox = false;
      newInnerMaterial.emissive.set(1, 1, 0.176);
      // newInnerMaterial.diffuse.set(0.663, 0.663, 0.027);
      newInnerMaterial.blendType = pc.BLEND_NONE;

      const outerRefs = [outerBoxRef, outerBox2Ref, outerBox3Ref];
      const opacities = [0.5, 0.2, 0.1];

      outerRefs.forEach((ref, index) => {
        if (ref.current) {
          const meshInstance = ref.current.render.meshInstances[0];
          const material = meshInstance.material.clone();
          meshInstance.material = material;

          material.emissiveMap = material.diffuseMap;
          material.emissiveIntensity = 2.5;
          material.emissive.set(0.996, 0.184, 0.016);
          material.useLighting = false;
          material.useSkybox = false;
          material.blendType = pc.BLEND_ADDITIVEALPHA;
          material.opacity = opacities[index];
          material.update();
        }
      });

      entityRef.current.setPosition(new pc.Vec3(start[0], start[1], start[2]));
      entityRef.current.lookAt(new pc.Vec3(end[0], end[1], end[2]));
      if (start[1] == end[1]) {
        entityRef.current.setLocalScale(0.05, 0.05, length);
        entityRef.current.translateLocal(0, -0.5, -length / 2);
      } else {
        entityRef.current.setLocalScale(0.05, 0.05, length + 0.075);
        entityRef.current.translateLocal(0, -0.45, -length / 2 + 0.2);
      }

      entityRef.current.enabled = false;
    }, []);

    const handleUpdate = useCallback((dt: number) => {
      if (entityRef.current == null) {
        return;
      }
      if (pathCorrespondingPercentage.current == -1) {
        const entries = Object.entries(
          latestNavigationPercentagePositionDictionary.current,
        );
        for (let i = 0; i < entries.length; i++) {
          if (
            end[0] == entries[i][1][0] &&
            end[1] == entries[i][1][1] &&
            end[2] == entries[i][1][2]
          ) {
            pathCorrespondingPercentage.current = entries[i][0];
          }
        }
      }
      if (
        latestProgressRef.current > pathCorrespondingPercentage.current &&
        latestXrayModeRef.current == 2 &&
        latestCameraModeRef.current == 1
      ) {
        entityRef.current.enabled = true;
      } else {
        entityRef.current.enabled = false;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={entityRef}>
        <Entity ref={innerBoxRef} scale={[1, 1, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBoxRef} scale={[1.2, 1.2, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox2Ref} scale={[1.4, 1.4, 1]}>
          <Render type="box" />
        </Entity>
        <Entity ref={outerBox3Ref} scale={[1.6, 1.6, 1]}>
          <Render type="box" />
        </Entity>
      </Entity>
    );
  };

  const MeshModels = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    return (
      <>
        {mapSettingState.modelConfig!.mesh.meshModels.map((item, index) => (
          <Fragment key={item.index}>
            <MeshModelComponent
              app={app}
              cameraName={"MainCamera"}
              meshUrl={
                baseUrl + mapSettingState.modelConfig!.folderPath + item.url
              }
              meshPosition={[
                item.position[0] / mapSettingState.modelConfig.scaleFactor,
                item.position[1] / mapSettingState.modelConfig.scaleFactor,
                item.position[2] / mapSettingState.modelConfig.scaleFactor,
              ]}
              meshRotationAngle={item.rotationAngle}
              meshScale={[
                item.scale[0] / mapSettingState.modelConfig.scaleFactor,
                item.scale[1] / mapSettingState.modelConfig.scaleFactor,
                item.scale[2] / mapSettingState.modelConfig.scaleFactor,
              ]}
              meshColor={item.color ?? "#FFFFFF"}
              meshOpacity={item.opacity ?? 1}
              rotateObjects={item.rotateObjects ?? []}
            />
          </Fragment>
        ))}
      </>
    );
  };

  const SingleLod = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const isSplatReadyRef = useRef(false);
    const worstLevelRef = useRef(2);
    const lodLink =
      baseUrl +
      mapSettingState.modelConfig!.folderPath +
      mapSettingState.modelConfig!.splat?.singleLod;

    const callbackAssetReadyFunction = (splat, asset) => {
      gsplatAllRef.current["single"] = splat;
      // console.log("single lod ready !!!!!!!!!");
      splat.gsplat.enabled = false;
      const worstLevel =
        splat.gsplat.resource?.octree?.lodLevels != null
          ? splat.gsplat.resource?.octree?.lodLevels - 1
          : 0;
      worstLevelRef.current = worstLevel;
      splat.gsplat.lodRangeMin = worstLevel;
      splat.gsplat.lodRangeMax = worstLevel;
      setTimeout(() => {
        afterReady();
      }, 1000);
    };
    const afterReady = () => {
      // console.log("afterReady");
      enableXRayMode();
      gsplatAllRef.current["single"].gsplat.lodRangeMin = 0;
      gsplatAllRef.current["single"].gsplat.lodRangeMax = worstLevelRef.current;

      transitionTimeoutRef.current = setTimeout(() => {
        setSceneAnimationState("orbit");
      }, 1000);
      revealEffectTimeoutRef.current = setTimeout(() => {
        if (
          gsplatAllRef.current["single"] != null &&
          gsplatAllRef.current["single"].gsplat != null
        ) {
          gsplatAllRef.current["single"].gsplat.enabled = true;
          createRadialScript(
            mainObjectEntityRef.current,
            gsplatAllRef.current["single"],
          );
        }
      }, 10);
    };

    useEffect(() => {
      isDisplayEnteringMaskRef.current = true;
    }, []);

    return (
      <SplatLodComponent
        app={app}
        url={lodLink}
        position={[0, 0, 0]}
        rotation={[180, 0, 0]}
        scale={[
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
        ]}
        lodDistances={mapSettingState.modelConfig.scaleFactor}
        callbackReady={callbackAssetReadyFunction}
      />
    );
  };

  const FloorLod = () => {
    const app = useApp();

    const checkFirstNode = () => {
      if (
        latestAllFloorMapAlignRef.current == null ||
        mapSettingRef.current.modelConfig == null ||
        latestNavigationDataRef.current == null
      ) {
        requestAnimationFrame(checkFirstNode);
      } else {
        const firstNode = latestNavigationDataRef.current.nav[0].navigation[0];
        const firstNodeMapAlign = findMapAlignWithGisLevelId(
          latestAllFloorMapAlignRef.current,
          firstNode.levelId,
          [firstNode.lng, firstNode.lat],
        );
        const firstNodeModelConfig = getModelConfigMapByLcMapId(
          mapSettingRef.current.modelConfig,
          firstNodeMapAlign.lcMapId,
        );
        if (firstNodeModelConfig.isNotReady) {
          setSceneAnimationState("orbit");
        }
      }
    };

    useEffect(() => {
      if (app) {
        requestAnimationFrame(checkFirstNode);
      }
    }, [app]);

    {
      return (
        <>
          {mapSettingState.modelConfig!.floor.map((item, index) =>
            item.lod ? (
              <Fragment key={index}>
                <EachFloorLod floorSetting={item} />
              </Fragment>
            ) : (
              <Fragment key={index}></Fragment>
            ),
          )}
        </>
      );
    }
  };

  const EachFloorLod = ({ floorSetting }) => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const assetModel = useRef();
    const isSplatReadyRef = useRef(false);
    const targetLodRangeMinRef = useRef(2);
    const worstLevelRef = useRef(2);
    const lodLink =
      baseUrl + mapSettingState.modelConfig!.folderPath + floorSetting.lod;

    const mapAlign = findMapAlignWithLcMapId(
      mapSettingState.floorAlignment,
      floorSetting.lcMapId,
    );
    const scaleFactor = SCALE_BASE / mapAlign.scale;
    const currentLcMapId = useNavigationStore((state) => state.currentLcMapId);

    const handleUpdate = useCallback((dt: number) => {
      if (floorSetting.lcMapId == currentLcMapIdRef.current) {
        splatDisplayFloor.current = floorSetting.displayLod;
      }
      if (
        gsplatAllRef.current[floorSetting.lcMapId] == null ||
        gsplatAllRef.current[floorSetting.lcMapId].gsplat == null ||
        splatDisplayFloor.current == null
      ) {
        return;
      }
      if (sceneAnimationStateRef.current == "previewFinish") {
        gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled = false;
      } else if (splatDisplayFloor.current) {
        if (
          splatDisplayFloor.current.includes(floorSetting.lcMapId) ||
          nextNodeLcMapIdRef.current == floorSetting.lcMapId
        ) {
          if (
            sceneAnimationStateRef.current == "init" ||
            sceneAnimationStateRef.current == "orbit" ||
            sceneAnimationStateRef.current == "preview" ||
            sceneAnimationStateRef.current == "stepByStep"
          ) {
            if (!gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled) {
              gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled = true;
              gsplatAllRef.current[floorSetting.lcMapId].gsplat.asset =
                assetModel.current;
              if (
                sceneAnimationStateRef.current == "init" ||
                sceneAnimationStateRef.current == "orbit" ||
                sceneAnimationStateRef.current == "preview" ||
                isAutoPlayingRef.current
              ) {
                requestAnimationFrame(showParticleEffect);
              } else {
                cleanup(app, gsplatAllRef.current[floorSetting.lcMapId]);
              }
            } else {
              if (
                gsplatAllRef.current[floorSetting.lcMapId].gsplat.lodRangeMin >
                targetLodRangeMinRef.current
              ) {
                //When current LOD is above 0 , wait for the current LOD display (e.g. LOD 2) and set the to higher quality LOD
                if (
                  !isSplatLoadingRef.current &&
                  splatLoadingCountRef.current == 0
                ) {
                  gsplatAllRef.current[
                    floorSetting.lcMapId
                  ].gsplat.lodRangeMin = targetLodRangeMinRef.current;
                  if (targetLodRangeMinRef.current > 0) {
                    setTimeout(() => {
                      targetLodRangeMinRef.current = 0;
                    }, 500);
                  }
                }
              }
            }
          }
        } else {
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.enabled = false;
          gsplatAllRef.current[floorSetting.lcMapId].gsplat.asset = null;
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);

    const showParticleEffect = () => {
      if (
        isNavigationMapChangingRef.current ||
        isDisplayEnteringMaskRef.current
      ) {
        requestAnimationFrame(showParticleEffect);
      } else {
        console.log("real showParticleEffect!!!!");
        gsplatAllRef.current[floorSetting.lcMapId].removeComponent("script");
        gsplatAllRef.current[floorSetting.lcMapId].addComponent("script");
        if (sceneAnimationStateRef.current == "orbit") {
          createRadialScript(
            mainObjectEntityRef.current,
            gsplatAllRef.current[floorSetting.lcMapId],
          );
        } else {
          createRadialScriptFast(
            mainObjectEntityRef.current,
            gsplatAllRef.current[floorSetting.lcMapId],
          );
        }
        setTimeout(() => {
          if (floorSetting.lcMapId == currentLcMapIdRef.current) {
            cleanup(app, gsplatAllRef.current[floorSetting.lcMapId]);
          } else {
          }
        }, 3000);
      }
    };

    const callbackAssetReadyFunction = (splat, asset) => {
      console.log("assets ready " + floorSetting.lcMapId);
      gsplatAllRef.current[floorSetting.lcMapId] = splat;
      assetModel.current = asset;
      // splat.gsplat.enabled = true;
      const worstLevel =
        splat.gsplat.resource?.octree?.lodLevels != null
          ? splat.gsplat.resource?.octree?.lodLevels - 1
          : 0;
      worstLevelRef.current = worstLevel;
      splat.gsplat.lodRangeMin = worstLevel;
      splat.gsplat.lodRangeMax = worstLevel;
      targetLodRangeMinRef.current =
        worstLevel > 0 ? worstLevel - 1 : worstLevel;
      setTimeout(() => {
        afterReady();
      }, 1000);
    };

    const afterReady = () => {
      console.log("afterReady");
      isSplatReadyRef.current = true;
      enableXRayMode();
      if (floorSetting.lcMapId == currentLcMapIdRef.current) {
        requestAnimationFrame(startOrbit);
      }
    };

    const startOrbit = () => {
      if (!isSplatLoadingRef.current && splatLoadingCountRef.current == 0) {
        setSceneAnimationState("orbit");
      } else {
        requestAnimationFrame(startOrbit);
      }
    };

    return (
      <>
        {currentLcMapId == floorSetting.lcMapId ? (
          <SplatLodComponent
            app={app}
            url={lodLink}
            position={[0, floorSetting.yAxis / scaleFactor, 0]}
            rotation={[180, 0, 0]}
            scale={[1 / scaleFactor, 1 / scaleFactor, 1 / scaleFactor]}
            lodDistances={scaleFactor}
            callbackReady={callbackAssetReadyFunction}
          />
        ) : (
          <></>
        )}
      </>
    );
  };

  const Splat = () => {
    return (
      <>
        {mapSettingState.modelConfig!.splat?.mode == "singleLod" ? (
          <SingleLod />
        ) : mapSettingState.modelConfig!.splat?.mode == "floorLod" ? (
          <FloorLod />
        ) : (
          <></>
        )}
      </>
    );
  };

  const AllFloorMeshGround = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    return (
      <>
        {mapSettingState.modelConfig!.floor.map((item, index) => {
          const mapAlign = findMapAlignWithLcMapId(
            mapSettingState.floorAlignment,
            item.lcMapId,
          );
          const scaleFactor = SCALE_BASE / mapAlign.scale;
          const meshY = item.yAxis / scaleFactor;
          const meshGroundUrl =
            baseUrl +
            mapSettingState.modelConfig!.folderPath +
            (item.meshGround ?? "");
          const meshObstacleUrl =
            baseUrl +
            mapSettingState.modelConfig!.folderPath +
            (item.meshObstacle ?? "");

          return (
            <Fragment key={item.lcMapId}>
              {item.meshGround ? (
                <>
                  <EachFloorMesh
                    app={app}
                    type={"ground"}
                    lcMapId={item.lcMapId}
                    meshUrl={meshGroundUrl}
                    meshPosition={[0, meshY, 0]}
                    meshRotation={[0, 180, 0]}
                    meshScale={[
                      1 / scaleFactor,
                      1 / scaleFactor,
                      1 / scaleFactor,
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
              {item.meshObstacle ? (
                <>
                  <EachFloorMesh
                    app={app}
                    type={"obstacle"}
                    lcMapId={item.lcMapId}
                    meshUrl={meshObstacleUrl}
                    meshPosition={[0, meshY, 0]}
                    meshRotation={[0, 180, 0]}
                    meshScale={[
                      1 / scaleFactor,
                      1 / scaleFactor,
                      1 / scaleFactor,
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
            </Fragment>
          );
        })}
      </>
    );
  };

  const EachFloorMesh = ({
    app,
    type,
    lcMapId,
    meshUrl,
    meshPosition,
    meshRotation,
    meshScale,
  }: {
    app: any;
    type: string;
    lcMapId: string;
    meshUrl: string;
    meshPosition: number[];
    meshRotation: number[];
    meshScale: number[];
  }) => {
    const [isFirstDisplayedState, setIsFirstDisplayedState] =
      useState<boolean>(false);
    const isFirstDisplayedRef = useRef<boolean>(false);
    const meshOpacity = 1;
    const meshEntityRef = useRef();
    const meshInnerEntityRef = useRef();
    const isCollisionSetRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);
    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = true;
              material.opacity = meshOpacity;
              material.blendType = pc.BLEND_NORMAL;
              material.depthWrite = false;
              material.update();
            }
          });
        }
      });
    };
    const enableCollision = () => {
      if (
        isFirstDisplayedRef.current &&
        meshInnerEntityRef.current?.collision != null &&
        meshAsset != null
      ) {
        meshInnerEntityRef.current.collision.type = "mesh";
        meshInnerEntityRef.current.collision.renderAsset =
          meshAsset.resource.renders[0];
        isCollisionSetRef.current = true;
      } else {
        requestAnimationFrame(() => {
          enableCollision();
        });
      }
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        meshEntityRef.current.enabled = false;
        requestAnimationFrame(() => {
          enableCollision();
        });
      }
    }, [meshAsset]);

    const handleUpdate = useCallback((dt: number) => {
      meshEntityRef.current.enabled =
        currentLcMapIdRef.current == lcMapId &&
        !isNavigationMapChangingRef.current &&
        !isNavigationReadyChangeMapRef.current;
      if (
        currentLcMapIdRef.current == lcMapId &&
        !isFirstDisplayedRef.current &&
        !isNavigationMapChangingRef.current
      ) {
        setIsFirstDisplayedState(true);
        isFirstDisplayedRef.current = true;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity
        ref={meshEntityRef}
        name={"FloorMesh_" + lcMapId}
        position={meshPosition}
        rotation={meshRotation}
        scale={meshScale}
        enabled={false}
      >
        {isFirstDisplayedState ? (
          <Entity ref={meshInnerEntityRef} name={type + "_" + lcMapId}>
            <RigidBody type="static" />
            <Collision type="box" convexHull={false} />
            {/*
              <Render type="asset" asset={meshAsset} />
            */}
          </Entity>
        ) : (
          <></>
        )}
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    appRef.current = app;

    function loadRigidbodySystem() {
      if (app.systems.rigidbody != null) {
        rigidbodySystemRef.current = app.systems.rigidbody;
      } else {
        requestAnimationFrame(loadRigidbodySystem);
      }
    }

    function waitForMainCamera() {
      if (mainCameraRef.current == null) {
        if (app.root.findByName("MainCamera")) {
          mainCameraRef.current = app.root.findByName("MainCamera");
        }
        requestAnimationFrame(waitForMainCamera);
      }
    }

    useEffect(() => {
      requestAnimationFrame(loadRigidbodySystem);
      requestAnimationFrame(waitForMainCamera);
    }, []);

    useEffect(() => {
      const splatLoadingUpdate = (camera, layer, ready, loadingCount) => {
        isSplatLoadingRef.current = !ready;
        splatLoadingCountRef.current = loadingCount;
      };
      if (app && app?.systems?.gsplat != null) {
        app.systems.gsplat.on("frame:ready", splatLoadingUpdate);
      }
      return () => {
        if (app && app?.systems?.gsplat != null) {
          app.systems.gsplat.off("frame:ready", splatLoadingUpdate);
        }
      };
    }, [app]);

    return (
      <>
        {/*<SimpleModel />*/}
        <WalkPathsContainer />
        <NavigationAutoPlayController />
        {/*{mapSettingState.modelConfig!.lod ? <VenueLod /> : <></>}*/}
        {mapSettingState.modelConfig!.splat ? <Splat /> : <></>}
        {mapSettingState.modelConfig!.mesh ? <MeshModels /> : <></>}
        {mapSettingState.modelConfig!.floorMesh ? (
          <FloorMeshContainer />
        ) : (
          <></>
        )}
        {mapSettingState.modelConfig!.floor ? <AllFloorMeshGround /> : <></>}
        {/*{mapSettingState.modelConfig!.floor ? (
          <AllThreeDimensionAnnotationTags />
        ) : (
          <></>
        )}*/}
        <Environment exposure={1} luminance={0.4} /> {/* Ambient fill */}
        <Entity>{/*<Light type="directional" intensity={50} />*/}</Entity>
        <MainObject />
        <MainCamera />
      </>
    );
  };

  const Scene = () => {
    return (
      <Application
        usePhysics={true}
        maxDeltaTime={0.033}
        timeScale={1.0}
        graphicsDeviceOptions={{
          powerPreference: "low-power",
          alpha: false,
          antialias: false,
          preferWebGl2: true,
          stencil: false,
        }}
      >
        {mapSettingState != null && mapSettingState.modelConfig != null ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const EnterLoading = () => {
    const [isDisplayMask, setIsDisplayMask] = useState<boolean>(true);
    const opacityRef = useRef<number>(1);
    const divRef = useRef<HTMLDivElement>(null);
    const EACH_OPACITY = 0.02;
    const animationRef = useRef<number>(0);
    const keepCheckLoading = () => {
      if (!isDisplayEnteringMaskRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      setIsDisplayMask(opacityRef.current > 0);

      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return isDisplayMask ? (
      <div
        ref={divRef}
        className={`fullscreen_div flex items-center justify-center z-[60]`}
      >
        <div className="fullscreen_div bg-[#FFFFFF99] backdrop-blur-md"></div>
        <div className="h-25 w-25 flex items-center justify-center">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const StartEndPoint = () => {
    const animationRef = useRef<number>(0);
    const EACH_OPACITY = 0.02;
    const startPointName = useNavigationStore((state) => state.startPointName);
    const endPointName = useNavigationStore((state) => state.endPointName);
    const divRef = useRef<HTMLDivElement>(null);
    const firstRef = useRef<HTMLDivElement>(null);
    const firstOpacityRef = useRef<number>(0);
    const secondRef = useRef<HTMLDivElement>(null);
    const secondOpacityRef = useRef<number>(0);
    const thirdRef = useRef<HTMLDivElement>(null);
    const thirdOpacityRef = useRef<number>(0);
    const startPointRef = useRef<HTMLDivElement>(null);
    const startPointOpacityRef = useRef<number>(0);
    const endPointRef = useRef<HTMLDivElement>(null);
    const endPointOpacityRef = useRef<number>(0);

    const keepCheckLoading = () => {
      if (!isDisplayStartEndPointFirstRef.current) {
        firstOpacityRef.current =
          firstOpacityRef.current > EACH_OPACITY
            ? firstOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        firstOpacityRef.current =
          firstOpacityRef.current < 1 - EACH_OPACITY
            ? firstOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointSecondRef.current) {
        secondOpacityRef.current =
          secondOpacityRef.current > EACH_OPACITY
            ? secondOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        secondOpacityRef.current =
          secondOpacityRef.current < 1 - EACH_OPACITY
            ? secondOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointThirdRef.current) {
        thirdOpacityRef.current =
          thirdOpacityRef.current > EACH_OPACITY
            ? thirdOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        thirdOpacityRef.current =
          thirdOpacityRef.current < 1 - EACH_OPACITY
            ? thirdOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointStartRef.current) {
        startPointOpacityRef.current =
          startPointOpacityRef.current > EACH_OPACITY
            ? startPointOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        startPointOpacityRef.current =
          startPointOpacityRef.current < 1 - EACH_OPACITY
            ? startPointOpacityRef.current + EACH_OPACITY
            : 1;
      }
      if (!isDisplayStartEndPointEndRef.current) {
        endPointOpacityRef.current =
          endPointOpacityRef.current > EACH_OPACITY
            ? endPointOpacityRef.current - EACH_OPACITY
            : 0;
      } else {
        endPointOpacityRef.current =
          endPointOpacityRef.current < 1 - EACH_OPACITY
            ? endPointOpacityRef.current + EACH_OPACITY
            : 1;
      }
      divRef.current.style.display = isDisplayStartEndPointDivRef.current
        ? ""
        : "none";
      firstRef.current.style.opacity = firstOpacityRef.current.toString();
      secondRef.current.style.opacity = secondOpacityRef.current.toString();
      thirdRef.current.style.opacity = thirdOpacityRef.current.toString();
      startPointRef.current.style.opacity =
        startPointOpacityRef.current.toString();
      endPointRef.current.style.opacity = endPointOpacityRef.current.toString();
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);

    return (
      <div ref={divRef} className={`fullscreen_div pointer-events-none`}>
        <div ref={firstRef}>
          <div className={`fullscreen_div flex items-center justify-center`}>
            <div className="w-full h-[4px] bg-[#E5E9EDE5]"></div>
          </div>
        </div>

        <div ref={secondRef}>
          <div className="absolute top-1/2 -translate-y-1/2 left-[0px] w-[calc(72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div className="absolute top-1/2 -translate-y-1/2 left-[calc(72px+6px+5px)] w-[calc(100%-72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>

          <div
            className={`absolute top-1/2 -translate-x-1/2 left-[72px] translate-y-[calc(-50%-9px)]`}
          >
            <Image src="/assets/icon_start_point.png" width={12} />
          </div>
        </div>

        <div ref={thirdRef}>
          <div className="absolute top-1/2 -translate-y-1/2 left-[0px] w-[calc(72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div className="absolute top-1/2 -translate-y-1/2 right-[0px] w-[calc(72px-6px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-72px-72px-6px-6px-5px-5px)] h-[4px] bg-[#E5E9EDE5]"></div>
          <div
            className={`absolute top-1/2 -translate-x-1/2 left-[72px] translate-y-[calc(-50%-9px)]`}
          >
            <Image src="/assets/icon_start_point.png" width={12} />
          </div>

          <div
            className={`absolute top-1/2 translate-x-1/2 right-[72px] translate-y-[calc(-50%+9px)]`}
          >
            <Image src="/assets/icon_end_point.png" width={12} />
          </div>
        </div>

        <div ref={startPointRef}>
          <div
            className={`absolute top-1/2 -translate-x-1/2 left-[72px] translate-y-[calc(-50%-45px)]`}
          >
            <Image src="/assets/icon_map_pin.png" height={36} width={36} />
          </div>
          <div
            className={`absolute h-[50%] left-1/2 top-1/2 -translate-y-full -translate-x-1/2 w-[calc(100%-72px-72px+12px+12px)]`}
          >
            <div
              className={`absolute bottom-[0%] pb-[65px] text-left text-[#E5E9EDE5] font-extrabold text-[40px]`}
            >
              {startPointName}
            </div>
          </div>
        </div>

        <div ref={endPointRef}>
          <div
            className={`absolute top-1/2 translate-x-1/2 right-[72px] translate-y-[calc(-50%+45px)]`}
          >
            <Image
              src="/assets/icon_destination_flag.png"
              height={36}
              width={36}
            />
          </div>

          <div
            className={`absolute h-[50%] left-1/2 top-1/2 -translate-x-1/2 w-[calc(100%-72px-72px+12px+12px)]`}
          >
            <div
              className={`absolute top-[0%] right-[0%] pt-[65px] text-right text-[#E5E9EDE5] font-extrabold text-[40px]`}
            >
              {endPointName}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const DragBlock = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const animation = () => {
      divRef.current.style.display = isEnableDragRef.current ? "none" : "";
      animationRef.current = requestAnimationFrame(() => {
        animation();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        animation();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);
    return <div ref={divRef} className={`fullscreen_div opacity-[0]`}></div>;
  };

  const BlackScreen = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<number>(0);
    const opacityRef = useRef<number>(0);
    const EACH_OPACITY = 0.1;
    const keepCheckLoading = () => {
      if (!isDisplayBlackScreenRef.current) {
        opacityRef.current =
          opacityRef.current > EACH_OPACITY
            ? opacityRef.current - EACH_OPACITY
            : 0;
      } else {
        opacityRef.current =
          opacityRef.current < 1 - EACH_OPACITY
            ? opacityRef.current + EACH_OPACITY
            : 1;
      }
      if (divRef.current) {
        divRef.current.style.opacity = opacityRef.current.toString();
      }
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
    };
    useEffect(() => {
      animationRef.current = requestAnimationFrame(() => {
        keepCheckLoading();
      });
      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }, []);
    return (
      <div
        ref={divRef}
        className={`fullscreen_div pointer-events-none bg-black z-[60]`}
      ></div>
    );
  };

  const ContinueButton = () => {
    const isShowNavigationContinueButton = useNavigationStore(
      (state) => state.isShowNavigationContinueButton,
    );
    const hasUserInteraction = useAppStore((state) => state.hasUserInteraction);
    const setHasUserInteraction = useAppStore(
      (state) => state.setHasUserInteraction,
    );
    const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);

    const { readText } = useMessagePlayer();
    return isShowNavigationContinueButton ? (
      <div
        className={`fullscreen_div flex items-center justify-center pointer-events-none`}
      >
        <div
          className={`flex flex-col w-[100px] h-[100px] bg-[#7676808C] items-center justify-center rounded-xl cursor-pointer pointer-events-auto`}
          onClick={() => {
            if (!hasUserInteraction) {
              readText("", voiceLanguage, true);
              setHasUserInteraction(true);
            }

            setIsShowNavigationContinueButton(false);
            isWaitingUserContinue.current = false;
            resumeAutoPlay(0);
          }}
        >
          <div className={`text-center`}>
            <Image
              src={"/assets/icon_navigation_play.png"}
              width={36}
              height={36}
            />
          </div>
          <div className={`text-center text-white`}>Continue</div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const RestartButton = () => {
    const isShowNavigationRestartButton = useNavigationStore(
      (state) => state.isShowNavigationRestartButton,
    );
    return isShowNavigationRestartButton ? (
      <div
        className={`fullscreen_div flex items-center justify-center pointer-events-none`}
      >
        <div
          className={`flex flex-col w-[100px] h-[100px] bg-[#7676808C] items-center justify-center rounded-xl cursor-pointer pointer-events-auto`}
          onClick={() => {
            setIsShowNavigationRestartButton(false);
            setCameraMode(0);
            isDisplayAvatarRef.current = false;
            resetSlider();
            resetPosition();
            // resumeAutoPlay(1);
          }}
        >
          <div className={`text-center`}>
            <Image
              src={"/assets/icon_navigation_repeat.png"}
              width={36}
              height={36}
            />
          </div>
          <div className={`text-center text-white`}>Restart</div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const SkipPreviewButton = () => {
    const isDisplaySkipPreview = useNavigationStore(
      (state) => state.isDisplaySkipPreview,
    );
    const navEventData = useNavigationStore((state) => state.navEventData);

    function skipPreview() {
      setIsDisplaySkipPreview(false);
      stopAutoPlay();
      finishPreview(0);
      trackEvent(AMPLITUDE_EVENT.NAV_PREVIEW_SKIPPED, {
        navToken: navEventData.get("navToken") ?? "",
        referrer: navEventData.get("referrer") ?? "",
      });
    }

    return isDisplaySkipPreview ? (
      <div
        className="absolute flex items-center justify-center bottom-[20px] right-[20px] w-[104px] h-[40px] rounded-3xl text-[#FFFFFF] bg-[#17192599]"
        onClick={() => {
          skipPreview();
        }}
      >
        <div className="mr-[8px] pointer-events-none select-none">Skip</div>
        <Image
          className="pointer-events-none select-none"
          src={"/assets/icon_skip.png"}
          width={24}
          height={24}
        />
      </div>
    ) : (
      <></>
    );
  };

  const TwoDimensionUI = () => {
    return (
      <div className="absolute top-0 left-0 w-full h-screen pointer-events-none">
        {mapSettingState?.modelConfig?.floor ? (
          <AllTwoDimensionAnnotationTags />
        ) : (
          <></>
        )}
      </div>
    );
  };

  const AllTwoDimensionAnnotationTags = () => {
    return (
      <>
        {mapSettingState?.modelConfig?.floor.map((item, index) => (
          <Fragment key={item.lcMapId}>
            <EachTwoDimensionAnnotationFloorTags
              lcMapId={item.lcMapId}
              floorY={item.yAxis}
              annotationJsonUrl={item.annotation}
            />
          </Fragment>
        ))}
      </>
    );
  };

  const EachTwoDimensionAnnotationFloorTags = ({
    lcMapId,
    floorY,
    annotationJsonUrl,
  }: {
    lcMapId: number;
    floorY: number;
    annotationJsonUrl: string;
  }) => {
    const baseUrl = getBaseUrl();
    const [annotationDataState, setAnnotationDataState] = useState(null);
    const annotationDataRef = useRef();
    const candidateAnnotationDataRef = useRef({});
    const mapAlign = findMapAlignWithLcMapId(
      mapSettingState.floorAlignment,
      lcMapId,
    );
    const scaleFactor = SCALE_BASE / mapAlign.scale;

    useEffect(() => {
      if (annotationJsonUrl && annotationDataState == null) {
        const url =
          baseUrl + mapSettingState.modelConfig!.folderPath + annotationJsonUrl;
        if (annotationJsonCacheRef.current[url]) {
          setAnnotationDataState(annotationJsonCacheRef.current[url]);
          annotationDataRef.current = annotationJsonCacheRef.current[url];
        } else {
          fetchAnnotationJsonData(url);
        }
        enableAnnotationMode();
        requestAnimationFrame(handlePositionUpdate);
      }
    }, []);
    async function fetchAnnotationJsonData(url: string) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Model Json Fetch failed");
        const jsonData = await response.json();
        setAnnotationDataState(jsonData);
        annotationDataRef.current = jsonData;
        annotationJsonCacheRef.current[url] = jsonData;
      } catch (err) {
        console.log(err);
      } finally {
      }
    }

    function setVisible(
      id: string,
      visible: boolean,
      screenPos?: AnnotationTagPositionType,
    ) {
      if (!visible) {
        annotationUIRef.current[
          "annotationTag_" + lcMapId + "_" + id
        ].style.display = "none";
      } else {
        annotationUIRef.current[
          "annotationTag_" + lcMapId + "_" + id
        ].style.display = "";
        annotationUIRef.current[
          "annotationTag_" + lcMapId + "_" + id
        ].style.left = screenPos.x + "px";
        annotationUIRef.current[
          "annotationTag_" + lcMapId + "_" + id
        ].style.top = screenPos.y + "px";
        annotationUIRef.current[
          "annotationTag_" + lcMapId + "_" + id
        ].style.zIndex = screenPos.z;
      }
    }

    function filterOverlapObjectIds(objects, allowDistance) {
      const list = Object.values(objects);
      list.sort((a, b) => a.screenPos.z - b.screenPos.z);
      const kept = [];
      for (const item of list) {
        const { x, y } = item.screenPos;
        let tooClose = false;
        for (const k of kept) {
          const dx = k.screenPos.x - x;
          const dy = k.screenPos.y - y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < allowDistance) {
            tooClose = true;
            break;
          }
        }
        if (!tooClose) {
          kept.push(item);
        }
      }
      const result = [];
      for (const item of kept) {
        result.push(item.id);
      }
      return result;
    }

    function handlePositionUpdate() {
      if (
        annotationDataRef.current != null &&
        mainCameraRef.current != null &&
        mainCameraRef.current.c.script != null
      ) {
        candidateAnnotationDataRef.current = {};
        const cameraPosition = mainCameraRef.current.getPosition();
        for (const [key, element] of Object.entries(
          annotationDataRef.current,
        )) {
          if (
            annotationUIRef.current[
              "annotationTag_" + lcMapId + "_" + element.id
            ] != null
          ) {
            if (
              lcMapId != currentLcMapIdRef.current ||
              latestAnnotationModeRef.current != 2
            ) {
              setVisible(element.id, false);
              continue;
            }

            const targetPosition = new pc.Vec3(
              (element.anchor[0] * -1) / scaleFactor,
              (floorY + element.anchor[1]) / scaleFactor,
              (element.anchor[2] * -1) / scaleFactor,
            );
            const uiDistance = vec3Distance(cameraPosition, targetPosition);
            if (uiDistance > 15) {
              setVisible(element.id, false);
              continue;
            }

            const screenPos =
              mainCameraRef.current.c.script.cameraControls._camera.worldToScreen(
                targetPosition,
              );
            if (
              screenPos.x < 15 ||
              screenPos.x > window.innerWidth - 50 ||
              screenPos.y < 15 ||
              screenPos.y > window.innerHeight - 15 ||
              screenPos.z < 0
            ) {
              setVisible(element.id, false);
              continue;
            }

            const newCandidateAnnotationData: AnnotationTagScreenPosType = {
              id: element.id,
              worldPos: targetPosition,
              screenPos: {
                x: screenPos.x,
                y: screenPos.y,
                z: screenPos.z,
              },
            };
            candidateAnnotationDataRef.current[element.id] =
              newCandidateAnnotationData;
          }
        }

        if (Object.entries(candidateAnnotationDataRef.current).length > 0) {
          const filteredOverlapAnnotationIds = filterOverlapObjectIds(
            candidateAnnotationDataRef.current,
            100,
          );
          for (const [key, element] of Object.entries(
            candidateAnnotationDataRef.current,
          )) {
            if (filteredOverlapAnnotationIds.includes(element.id)) {
              if (appRef.current.systems.rigidbody != null) {
                const hit = appRef.current.systems.rigidbody.raycastFirst(
                  cameraPosition,
                  element.worldPos,
                );
                if (hit) {
                  const hitDistance = vec3Distance(element.worldPos, hit.point);
                  if (hitDistance > 1) {
                    setVisible(element.id, false);
                    continue;
                  }
                }
              }
              setVisible(element.id, true, element.screenPos);
              continue;
            } else {
              setVisible(element.id, false);
              continue;
            }
          }
        }
      }

      requestAnimationFrame(handlePositionUpdate);
    }

    return (
      <>
        {annotationDataState ? (
          annotationDataState.map((item, index) => {
            const targetPosition = new pc.Vec3(
              (item.anchor[0] * -1) / scaleFactor,
              (floorY + item.anchor[1]) / scaleFactor,
              (item.anchor[2] * -1) / scaleFactor,
            );

            let annotationColor = "#FFFFFF";
            if (annotationColorRef.current[item.label] == null) {
              const randomColor =
                AnnotationTagColorPool[
                  Math.floor(Math.random() * AnnotationTagColorPool.length)
                ];
              annotationColor = annotationColor;
              annotationColorRef.current[item.label] = randomColor;
            } else {
              annotationColor = annotationColorRef.current[item.label];
            }

            return (
              <Fragment key={item.id}>
                <EachTwoDimensionAnnotationTag
                  index={index}
                  id={item.id}
                  lcMapId={lcMapId}
                  targetPosition={targetPosition}
                  text={item.label}
                  color={annotationColor}
                />
              </Fragment>
            );
          })
        ) : (
          <></>
        )}
      </>
    );
  };

  const EachTwoDimensionAnnotationTag = ({
    index,
    id,
    lcMapId,
    targetPosition,
    text,
    color,
  }: {
    index: string;
    id: string;
    lcMapId: string;
    targetPosition: pc.Vec3;
    text: string;
    color: string;
  }) => {
    useEffect(() => {
      //requestAnimationFrame(handlePositionUpdate);
    }, []);

    return (
      <div
        className="absolute left-[-100px] top-[-10px] inline-flex items-center gap-2 rounded-full bg-black/80 px-3 py-1 -translate-x-1/2 -translate-y-1/2"
        style={{ display: "none" }}
        ref={(el) => {
          annotationUIRef.current["annotationTag_" + lcMapId + "_" + id] = el;
        }}
      >
        <span
          className="h-[10px] w-[10px] rounded-full shrink-0"
          style={{ backgroundColor: color }}
        />
        <span className="whitespace-nowrap text-sm font-medium text-white">
          {text}
        </span>
      </div>
    );
  };

  console.log(
    "NavigationPage component rendered , if this keep showing, something wrong",
  );

  return (
    <>
      <div className="absolute top-0 left-0 w-full h-full">
        <DataController />
        <Scene />
        <MapBlockingScreen />
        <WatermarkScreen />
        <DebugKeyListener />
        <EnterLoading />
        <StartEndPoint />
        <ContinueButton />
        <RestartButton />
        <LoadingMask />
        <BlackScreen />
        <DragBlock />
        <SkipPreviewButton />
        <TwoDimensionUI />
      </div>
    </>
  );
}
